/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-inline-comments */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import logo from '../../assets/ThinkLead.svg'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { signInWithEmailAndPassword, signInWithGoogle, signUpNewUsers, resetUserPassword, clearAllLockoutsForUser, sendEmailVerificationBypass, verifyEmailBypassToken, getUserPhoneNumber, recordFailedOTPAttempt, checkOTPLockoutStatus, clearOTPLockout, signInWithEmailAndPasswordEnhanced, checkDeviceTrustStatus, addDeviceToTrustedList, removeDeviceFromTrustedList } from '../../store/actions/authActions'
import firebase from '../../store/firebase'
import {
  createCompanyUser,
  checkUserIs
} from '../../store/actions/companyAdminActions'
import Media from 'react-media'
import ForgotPassword from './ForgotPassword'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
// FormControlLabel already imported in grouped import below
import { SHOW_LOADER } from '../../store/actions/types'
import { SHOW_TOAST, LOGIN_SUCCESS
} from '../../store/actions/types'
import { showToast } from '../../store/actions/toastAction'
import { hideLoader, showLoader } from '../../store/actions/loaderActions'
import WindowsDButton from './windowsdbutton'
import { 
  APP_TYPE, 
  SERVER_TYPE, 
  IS_HARMONY, 
  GET_ALL_COMPANY_SETTINGS,
  GET_ALL_GENERAL_SETTINGS,
  FB_URL
} from '../../store/actions/types'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import harmonyImg from '../../assets/harmony/LDPportal.jpg'
import {
  FormControl,
  MenuItem,
  input,
  InputLabel,
  Radio,
  FormControlLabel
} from '@material-ui/core'
import Popover from '@material-ui/core/Popover'
import Hidden from '@material-ui/core/Hidden'
import CssBaseline from '@material-ui/core/CssBaseline'
import Container from '@material-ui/core/Container'
//import ThinkLeadLogo from '../../assets/thinkleadEcosystem.jpg'
//import ThinkLeadLogo from '../../assets/mevision04.png'
//import ThinkLeadLogo from './img/mevLand.jpg'
import ThinkLeadLogo from '../../assets/dennis-logo.png'
import dennisLogo from '../../assets/dennis-logo.png'
import mevImage from "./img/mevLand.jpg";

import { THEMECOLOR } from '../../utils/color_utils'
import SvgIcon from '@material-ui/core/SvgIcon'
import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import {
  getAllCompanySettings,
  getAllGeneralSettings,
} from '../../store/actions/companyAdminActions'
import axios from 'axios';
import EmailVerification from './EmailVerification';
import firebaseCompat from '../../utils/firebaseCompat';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  // Ensure the page itself doesn't scroll/jump when the menu is open
  disableScrollLock: true,
};

const useStyles = makeStyles(theme => ({
  root: {
  },
  snackbar: {
    margin: theme.spacing(1)
  },
  formControl: {
    'width': '100%',
    '& label span': {
      color: 'red'
    }
  }
}))

const coverPageHeader = {
  // marginBottom: 26,
  fontFamily: 'Roboto',
  fontSize: '1.2rem'
}

const coverPageText = {
  // marginBottom: 15,
  fontFamily: 'Roboto',
  fontSize: '0.9rem'
}

const coverPagePoints = {
  color: '#BE2528'
}

// ===============
const ImgLogo = {
  marginTop: '-170px'
}

const ImgLogoSm = {
  marginTop: '-140px'
}


// ===============
const coverPageTextDiv = {
  marginTop: -180
}

const coverPageTextDivSm = {
  marginTop: -100
}

function GoogleIcon(props) {
  return (
    <SvgIcon {...props} fill='#000000' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='64px' height='64px'>
      <path d='M 16.003906 14.0625 L 16.003906 18.265625 L 21.992188 18.265625 C 21.210938 20.8125 19.082031 22.636719 16.003906 22.636719 C 12.339844 22.636719 9.367188 19.664063 9.367188 16 C 9.367188 12.335938 12.335938 9.363281 16.003906 9.363281 C 17.652344 9.363281 19.15625 9.96875 20.316406 10.964844 L 23.410156 7.867188 C 21.457031 6.085938 18.855469 5 16.003906 5 C 9.925781 5 5 9.925781 5 16 C 5 22.074219 9.925781 27 16.003906 27 C 25.238281 27 27.277344 18.363281 26.371094 14.078125 Z'/>
    </SvgIcon>
  )
}

// ===============
const LoginButton = withStyles(() => ({
  root: {
    'marginTop': 20,
    'marginRight': 5,
    'backgroundColor': '#ffde59',
    'borderRadius': 3,
    'border': 0,
    'color': 'white',
    'height': 48,
    'padding': '0 20px',
    '&:hover': {
      backgroundColor: '#ffd11a'
    }
  },
  hover: {},
  label: {
    textTransform: 'uppercase'
  }
}))(Button)

const SignInButton = withStyles(() => ({
  root: {
    'marginTop': 200,
    'marginRight': 5,
    'backgroundColor': '#ffde59',
    'borderRadius': 3,
    'border': 0,
    'color': '#ffde59',
    'height': 48,
    'padding': '0 20px',
    '&:hover': {
      backgroundColor: '#ffd11a'
    }
  },
  hover: {},
  label: {
    textTransform: 'uppercase'
  }
}))(Button)

// ===============
const GoogleButton = withStyles(() => ({
  root: {
    'marginTop': 20,
    'marginLeft': 5,
    'backgroundColor': '#ffde59',
    'borderRadius': 3,
    'border': 0,
    'color': 'white',
    'height': 48,
    'padding': '0 20px',
    '&:hover': {
      backgroundColor: '#ffde59'
    }
  },
  label: {
    textTransform: 'uppercase'
  }
}))(Button)

// ===============
// Design tokens — MEV Ecosystem auth shell.
// Base:   #0a1244 / #1025a2  (deep navy → brand blue, unchanged brand color)
// Accent: #ffde59 / #f5c518  (gold, unchanged brand color)
// Ink:    #10142b            (headings on white)
// Muted:  #667085            (helper copy on white)
const RADIUS = 18
const FIELD_RADIUS = 10

const styles = {
  // Keeps the overscroll/rubber-band edges the same tone as the gradient
  // below, instead of the browser's default white body background.
  '@global': {
    'html, body': {
      backgroundColor: '#070c3a',
      margin: 0,
      padding: 0
    }
  },

  root: {
    margin: '15px'
  },
  paper: {
    textAlign: 'center',
    color: '#efefef'
  },
  menuButton: {
    marginRight: 20
  },
  textField: {
    marginLeft: 10,
    marginRight: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },

  // Full-bleed backdrop the auth card floats on.
  pageWrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 16px',
    background: 'radial-gradient(120% 140% at 15% 10%, #1a34c2 0%, #0e1c7d 45%, #070c3a 100%)',
    boxSizing: 'border-box',
    '@media (max-width: 599px)': {
      minHeight: 'auto',
      padding: '16px 10px 32px',
      alignItems: 'flex-start'
    }
  },

  // The two-column card itself.
  authShell: {
    width: '100%',
    maxWidth: 980,
    margin: '0 auto',
    borderRadius: RADIUS,
    overflow: 'hidden',
    boxShadow: '0 30px 80px rgba(4, 8, 40, 0.45), 0 2px 0 rgba(255,255,255,0.04) inset',
    backgroundColor: '#ffffff'
  },

  // Left column — brand / story panel (desktop only).
  brandPanel: {
    position: 'relative',
    minHeight: 640,
    height: '100%',
    backgroundColor: '#0b1450',
    overflow: 'hidden'
  },
  brandOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '36px 32px 160px', 
    background: 'linear-gradient(180deg, rgba(10,20,80,0.15) 0%, rgba(7,12,58,0.55) 55%, rgba(6,10,48,0.92) 100%)'
  },
  brandLogoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 22
  },
  brandWordmark: {
    color: '#ffffff',
    fontWeight: 700,
    fontSize: '1.05rem',
    letterSpacing: '0.02em'
  },
  brandHeading: {
    color: '#ffffff',
    fontWeight: 700,
    lineHeight: 1.25,
    marginBottom: 12
  },
  brandSub: {
    color: 'rgba(255,255,255,0.78)',
    fontSize: '0.95rem',
    lineHeight: 1.6,
    maxWidth: 360,
    marginBottom: 22
  },
  brandBadgeRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8
  },
  brandBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '7px 13px',
    borderRadius: 999,
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#ffde59',
    border: '1px solid rgba(255,222,89,0.45)',
    backgroundColor: 'rgba(255,222,89,0.08)'
  },

  // Right column — the actual form panel.
  formPanel: {
    backgroundColor: '#ffffff',
    padding: '44px 40px',
    minHeight: 640,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '@media (max-width: 599px)': {
      minHeight: 'auto',
      padding: '24px 20px',
      justifyContent: 'flex-start'
    }
  },
  formEyebrow: {
    color: '#1025a2',
    fontWeight: 700,
    fontSize: '0.78rem',
    letterSpacing: '0.04em',
    marginBottom: 6
  },
  formHeading: {
    color: '#10142b',
    fontWeight: 700,
    marginBottom: 6
  },
  formSubtext: {
    color: '#667085',
    fontSize: '0.92rem',
    marginBottom: 22,
    lineHeight: 1.5
  },

  button: {
    'marginTop': 18,
    'backgroundColor': '#ffde59',
    'borderRadius': FIELD_RADIUS,
    'border': 0,
    'color': '#10142b',
    'height': 50,
    'padding': '0 22px',
    'fontWeight': 700,
    'boxShadow': '0 8px 20px rgba(255, 222, 89, 0.35)',
    '&:hover': {
      backgroundColor: '#f5c518',
      boxShadow: '0 10px 24px rgba(255, 222, 89, 0.45)'
    },
    'textTransform': 'none'
  },
  createAccount: {
    'marginRight': 0,
    'backgroundColor': 'transparent',
    'borderRadius': 999,
    'border': '1px solid #d7dcf5',
    'color': '#1025a2',
    'height': 40,
    'padding': '0 16px',
    'textDecoration': 'none',
    'display': 'inline-block',
    'textAlign': 'center',
    'lineHeight': '38px',
    'fontWeight': 600,
    'textTransform': 'none',
    'whiteSpace': 'nowrap',
    'minWidth': '120px',
    'fontSize': '13px',
    '&:hover': {
      backgroundColor: '#f4f6ff',
      cursor: 'pointer'
    }
  },
  main: {
    marginTop: '20vh'
  }
}

// Utility function to trim all string fields in an object
function trimAllStrings(obj) {
  const trimmed = {};
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      trimmed[key] = obj[key].trim();
    } else {
      trimmed[key] = obj[key];
    }
  }
  return trimmed;
}

// ===============
class BodyContent extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this);

  this.state = {
    //username: '',
    userpassword: '',
    open: true,
    openPolicy: false,
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    showPassword: false,
    agreeTCs: false,
    isHarmony: IS_HARMONY,
    selectClub: '-NRbTwxbqFLepk62Eq6M', // Correct ID for Me-Vision Academy
    clubName: 'Me-Vision Academy',
    //clubName: 'ThinkLead Ecosystem',
    department: '',
    position: '',//'Position/Title',
    positionHead: 'Position/Title',
    showLogin: true,
    directJoin: false,
    nationality: '',
    // OTP / TOTP related states
    otp: '',
    showOtpField: false,
    otpSent: false,
    otpMethod: 'totp',
    phoneNumber: '',
    // Security Level States
    securityLevel: 'level1', // Default to Level 1 (standard login)
    showSecuritySelector: true,
    // Escalation States
    needsEscalation: false,
    showEmailVerification: false,
    emailVerificationToken: '',
    lockoutCount: 0,
    phoneNumberStatus: 'missing',
    //message: '',
    //verifieduser: false, // Your state variable
    //setEmail: true,
    verifieduser: false,  // Always start false
    setEmail: true,       // Always allow email input
    message: '',
    error: '',
    loading: false,
    showPasswordResetForm: false,
    resetEmail: '',
    resetOobCode: '',
    newPassword: '',
    confirmPassword: '',
    isSubmitting: false,
    isSubmitting_confirmEmail: false,
    isSubmitting_signInEmailx: false,
    isSubmitting_signInGoogle: false,
    isSubmitting_SignUpWithEmail: false,
    pendingLinkToken: '',
    totpTimingStatus: '',
  };
}

componentDidMount() {
    // ---- Save Telegram link token from URL if present ----
  const linkToken = new URLSearchParams(window.location.search).get('linkToken');
  if (linkToken) {
    localStorage.setItem('pendingLinkToken', linkToken);
    this.setState({ pendingLinkToken: linkToken });
    console.log('about.js: saved linkToken from URL =', linkToken);
  }
  // -----------------------------------------------------
  // Check for pending Telegram link on every load
  const pendingToken = localStorage.getItem('pendingLinkToken');
  const storedUser = localStorage.getItem('USER_LOGGED_IN');
  console.log('about.js: pendingToken =', pendingToken);
  console.log('about.js: storedUser =', storedUser ? 'found' : 'null');
  
  if (pendingToken && storedUser) {
    try {
      const userObj = JSON.parse(storedUser);
      if (userObj.uid) {
        console.log('about.js: completing Telegram link on mount');
        localStorage.removeItem('pendingLinkToken');
        axios.post(`${FB_URL}m126-completeTelegramLink`, {
          token: pendingToken,
          firebaseUid: userObj.uid,
        })
        .then(res => console.log('about.js: Telegram link result =', res.data))
        .catch(err => console.error('about.js: Telegram link error =', err));
      }
    } catch (err) {
      console.error('about.js: error parsing user =', err);
    }
  }

  console.log('verifystate: verifieduser 1: ', this.state.verifieduser);
  console.log('verifystate: setEmail 1: ', this.state.setEmail);
  console.log('verifystate: showLogin 1: ', this.state.showLogin);

  let search = window.location.search;

  // 1. Restore confirmed state from sessionStorage (survives sign-out)
  const isConfirmed = sessionStorage.getItem('emailConfirmedThisSession') === 'true';
  const confirmedEmail = sessionStorage.getItem('confirmedEmailThisSession') || '';

  if (isConfirmed) {
    this.setState({
      verifieduser: true,
      setEmail: false,
      username: confirmedEmail,
      message: 'Email confirmed! Enter your password to log in.',
    });
  }

  // 2. HANDLE PASSWORD RESET LINK — HIGHEST PRIORITY
  const urlParams = new URLSearchParams(search);
  const mode = urlParams.get('mode');
  const oobCode = urlParams.get('oobCode');

  if (mode === 'resetPassword' && oobCode) {
    this.setState({ loading: true, message: '', error: '' });

    firebaseCompat.auth()
      .verifyPasswordResetCode(oobCode)
      .then((email) => {
        this.setState({
          showPasswordResetForm: true,
          resetEmail: email,
          resetOobCode: oobCode,
          loading: false,
          message: `Enter a new password for ${email}`,
        });
        window.history.replaceState({}, document.title, window.location.pathname);
      })
      .catch((error) => {
        let errorMessage = 'Invalid or expired password reset link.';
        if (error.code === 'auth/expired-action-code') errorMessage = 'This reset link has expired.';
        if (error.code === 'auth/invalid-action-code') errorMessage = 'This reset link is invalid.';

        this.setState({
          error: errorMessage,
          loading: false,
        });
        window.history.replaceState({}, document.title, window.location.pathname);
      });

    return; // STOP HERE — very important
  }

if (search && 
    !firebaseCompat.auth().isSignInWithEmailLink(window.location.href) &&
    !new URLSearchParams(search).get('linkToken')) {
  const appName = search.split("=")[1];
  if (appName && appName.length > 1) {
    this.setState({
      showLogin: false,
      directJoin: true,
      selectClub: appName
    });
  }
}
  this.setState({
    selectClub: '-NRbTwxbqFLepk62Eq6M',
    clubName: 'Me-Vision Academy'
  });

  this.props.getAllGeneralSettings({});
  this.props.getAllCompanySettings({});
  this.loadUserSecurityPreference();

  // 4. Handle email confirmation link
  if (firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
    // ... your existing email link code (unchanged)
    // Keep this exactly as it was working before
    let email = localStorage.getItem('emailForSignIn');

    if (!email) email = window.prompt('Please re-enter your email to confirm:');

    if (!email || email.trim() === '') {
      this.setState({ error: 'Confirmation cancelled.' });
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    email = email.trim();

    this.setState({ loading: true });

    firebaseCompat.auth()
      .signInWithEmailLink(email, window.location.href)
      .then(() => {
        localStorage.removeItem('emailForSignIn');

        sessionStorage.setItem('emailConfirmedThisSession', 'true');
        sessionStorage.setItem('confirmedEmailThisSession', email);

        this.setState({
          verifieduser: true,
          setEmail: false,
          username: email,
          message: 'Email confirmed! Enter your password to log in.',
          loading: false,
        });

        // Backend call
        const safeEmail = email.replace(/\./g, '_');
        const updates = {};
        updates[`/emailconfirmations/${safeEmail}`] = {
          timestamp: Date.now(),
          email: email,
          status: true
        };

        axios.post(`${FB_URL}/m115-freshcard`, { updates })
          .then(res => console.log('emailconfirmations: saved', res.data))
          .catch(err => console.error('Backend save failed:', err));
        
        sessionStorage.removeItem('reAuthRequired');
        return firebaseCompat.auth().signOut();
      })
.then(() => {
  // DEBUG — remove after testing
  const debugContinueUrl = new URLSearchParams(window.location.search).get('continueUrl');
  document.title = 'CU:' + (debugContinueUrl || 'null');
  // END DEBUG
  const urlParams = new URLSearchParams(window.location.search);
  const continueUrl = urlParams.get('continueUrl') || '';
  
  if (continueUrl.includes('/AgentSignup')) {
    // Extract linkToken from continueUrl and redirect with confirmed email
    const continueParams = new URLSearchParams(continueUrl.split('?')[1] || '');
    const linkToken = continueParams.get('linkToken') || '';
    const confirmedEmail = email; // email is in scope from the outer .then()
    
    sessionStorage.setItem('agentEmailConfirmed', 'true');
    sessionStorage.setItem('agentConfirmedEmail', confirmedEmail);
    if (linkToken) localStorage.setItem('pendingLinkToken', linkToken);
    
    window.location.href = `/AgentSignup${linkToken ? '?linkToken=' + linkToken : ''}`;
    return;
  }

  // Normal flow
  const pendingToken = localStorage.getItem('pendingLinkToken');
  if (pendingToken) {
    window.history.replaceState({}, document.title, `${window.location.pathname}?linkToken=${pendingToken}`);
  } else {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
})
      .catch((err) => {
        this.setState({
          error: 'Invalid or expired link.',
          loading: false,
        });
        window.history.replaceState({}, document.title, window.location.pathname);
      });

    return;
  }

  // NO GLOBAL AUTO-SIGNOUT LISTENER
}

componentDidMount_Feb27_2026() {
  console.log('verifystate: verifieduser 1: ', this.state.verifieduser);
  console.log('verifystate: setEmail 1: ', this.state.setEmail);
  console.log('verifystate: showLogin 1: ', this.state.showLogin);

  let search = window.location.search;

  // Restore confirmed state from sessionStorage (this survives sign-out)
  const isConfirmed = sessionStorage.getItem('emailConfirmedThisSession') === 'true';
  const confirmedEmail = sessionStorage.getItem('confirmedEmailThisSession') || '';

  if (isConfirmed) {
    this.setState({
      verifieduser: true,
      setEmail: false,
      username: confirmedEmail,
      message: 'Email confirmed! Enter your password to log in.',
    });
  }

  // Handle directJoin only if not a confirmation link
  if (search && !firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
    const appName = search.split("=")[1];
    if (appName && appName.length > 1) {
      this.setState({
        showLogin: false,
        directJoin: true,
        selectClub: appName
      });
    }
  }

  this.setState({
    selectClub: '-NRbTwxbqFLepk62Eq6M',
    clubName: 'Me-Vision Academy'
  });

  this.props.getAllGeneralSettings({});
  this.props.getAllCompanySettings({});
  this.loadUserSecurityPreference();

  // Handle email confirmation link
  if (firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
    let email = localStorage.getItem('emailForSignIn');

    if (!email) {
      email = window.prompt('Please re-enter your email to confirm:');
    }

    if (!email || email.trim() === '') {
      this.setState({ error: 'Confirmation cancelled.' });
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    email = email.trim();

    this.setState({ loading: true });

    firebaseCompat.auth()
      .signInWithEmailLink(email, window.location.href)
      .then(() => {
        localStorage.removeItem('emailForSignIn');

        // Save confirmed state to sessionStorage (survives sign-out)
        sessionStorage.setItem('emailConfirmedThisSession', 'true');
        sessionStorage.setItem('confirmedEmailThisSession', email);

        this.setState({
          verifieduser: true,
          setEmail: false,
          username: email,
          message: 'Email confirmed! Enter your password to log in.',
          loading: false,
        });

        // Backend call (your existing code)
        const safeEmail = email.replace(/\./g, '_');
        const updates = {};
        updates[`/emailconfirmations/${safeEmail}`] = {
          timestamp: Date.now(),
          email: email,
          status: true
        };

        axios.post(`${FB_URL}/m115-freshcard`, { updates })
          .then(res => console.log('emailconfirmations: saved', res.data))
          .catch(err => console.error('Backend save failed:', err));

        // Sign out the temporary user
        sessionStorage.removeItem('reAuthRequired');
        return firebaseCompat.auth().signOut();
      })
      .then(() => {
        window.history.replaceState({}, document.title, window.location.pathname);
      })
      .catch((err) => {
        this.setState({
          error: 'Invalid or expired link.',
          loading: false,
        });
        window.history.replaceState({}, document.title, window.location.pathname);
      });

    return;
  }

  // NO GLOBAL AUTO-SIGNOUT LISTENER
}

componentDidMount_Feb20_2026() {
  console.log('verifystate: verifieduser 1: ', this.state.verifieduser);
  console.log('verifystate: setEmail 1: ', this.state.setEmail);
  console.log('verifystate: showLogin 1: ', this.state.showLogin);

  let search = window.location.search;

  // === HANDLE PASSWORD RESET LINK ===
  const urlParams = new URLSearchParams(search);
  const mode = urlParams.get('mode');
  const oobCode = urlParams.get('oobCode');

  if (mode === 'resetPassword' && oobCode) {
    this.setState({ loading: true, message: '', error: '' });

    firebaseCompat.auth()
      .verifyPasswordResetCode(oobCode)
      .then((email) => {
        this.setState({
          showPasswordResetForm: true,
          resetEmail: email,
          resetOobCode: oobCode,
          loading: false,
          message: `Enter a new password for ${email}`,
        });
        // Clean the URL (optional, but nice UX)
        window.history.replaceState({}, document.title, window.location.pathname);
      })
      .catch((error) => {
        let errorMessage = 'Invalid or expired password reset link.';
        if (error.code === 'auth/expired-action-code') {
          errorMessage = 'This reset link has expired.';
        } else if (error.code === 'auth/invalid-action-code') {
          errorMessage = 'This reset link is invalid.';
        }
        this.setState({
          error: errorMessage,
          loading: false,
        });
        window.history.replaceState({}, document.title, window.location.pathname);
      });

    // Stop further processing
    return;
  }

  // Handle directJoin only if not a confirmation link
  if (search && !firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
    const appName = search.split("=")[1];
    if (appName && appName.length > 1) {
      this.setState({
        showLogin: false,
        directJoin: true,
        selectClub: appName
      });
    }
  }

  this.setState({
    selectClub: '-NRbTwxbqFLepk62Eq6M',
    clubName: 'Me-Vision Academy'
  });

  this.props.getAllGeneralSettings({});
  this.props.getAllCompanySettings({});
  this.loadUserSecurityPreference();

  // === HANDLE EMAIL CONFIRMATION LINK (existing logic) ===
// === HANDLE EMAIL CONFIRMATION LINK (only if it's actually an email link) ===
if (firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
  let email = localStorage.getItem('emailForSignIn');

  if (!email) {
    email = window.prompt('Please re-enter your email to confirm:');
  }

  if (!email || email.trim() === '') {
    this.setState({ error: 'Confirmation cancelled.' });
    window.history.replaceState({}, document.title, window.location.pathname);
    return;
  }

  email = email.trim();

  this.setState({ loading: true });

  firebaseCompat.auth()
    .signInWithEmailLink(email, window.location.href)
    .then((result) => {
      localStorage.removeItem('emailForSignIn');

      this.setState({
        verifieduser: true,
        setEmail: false,
        username: email,
        message: 'Email confirmed! Enter your password to log in.',
        loading: false,
      });

      // === BACKEND CALL - FIRE AND FORGET ===
      const safeEmail = email.replace(/\./g, '_');
      const updates = {};
      updates[`/emailconfirmations/${safeEmail}`] = {
        timestamp: Date.now(),
        email: email,
        status: true
      };

      axios.post(`${FB_URL}/m115-freshcard`, {
        params: { updates }
      })
      .then(res => console.log('emailconfirmations: saved', res.data))
      .catch(err => console.error('Backend save failed:', err));

      // === ONLY SIGN OUT IF WE JUST COMPLETED EMAIL LINK SIGN-IN ===
      // This prevents kicking out users who logged in normally
    
      return firebaseCompat.auth().signOut();
    })
    .then(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    })
    .catch((err) => {
      console.error('Email link sign-in failed:', err);
      this.setState({
        error: 'Invalid or expired confirmation link.',
        loading: false,
      });
      window.history.replaceState({}, document.title, window.location.pathname);
    });

  return; // Prevent further execution
}
}

componentDidMount_default() {
  console.log('verifystate: verifieduser 1: ', this.state.verifieduser);
  console.log('verifystate: setEmail 1: ', this.state.setEmail);
  console.log('verifystate: showLogin 1: ', this.state.showLogin);

  let search = window.location.search;

  // Handle directJoin only if not a confirmation link
  if (search && !firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
    const appName = search.split("=")[1];
    if (appName && appName.length > 1) {
      this.setState({
        showLogin: false,
        directJoin: true,
        selectClub: appName
      });
    }
  }

  this.setState({
    selectClub: '-NRbTwxbqFLepk62Eq6M',
    clubName: 'Me-Vision Academy'
  });

  this.props.getAllGeneralSettings({});
  this.props.getAllCompanySettings({});
  this.loadUserSecurityPreference();

// Handle email confirmation link
if (firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
  let email = localStorage.getItem('emailForSignIn');

  if (!email) {
    email = window.prompt('Please re-enter your email to confirm:');
  }

  if (!email || email.trim() === '') {
    this.setState({ error: 'Confirmation cancelled.' });
    window.history.replaceState({}, document.title, window.location.pathname);
    return;
  }

  email = email.trim();

  this.setState({ loading: true });

  firebaseCompat.auth()
    .signInWithEmailLink(email, window.location.href)
    .then(() => {
      localStorage.removeItem('emailForSignIn');

      this.setState({
        verifieduser: true,
        setEmail: false,
        username: email,
        message: 'Email confirmed! Enter your password to log in.',
        loading: false,
      });

      // === BACKEND CALL - FIRE AND FORGET ===
      const safeEmail = email.replace(/\./g, '_');  // Replace all dots with underscores

      const updates = {};
      updates[`/emailconfirmations/${safeEmail}`] = {
        timestamp: Date.now(),
        email: email,  // Keep the original email for reference
        status: true
      };

     axios.post(`${FB_URL}/m115-freshcard`, {
                      params: {
                          updates: updates, //user wallet address                       
                      }
                })
        .then(res => {
          console.log('emailconfirmations: saved', res.data);
        })
        .catch(err => {
          console.error('Backend save failed:', err);
        });
      // =======================================

      // Original working sign-out
      return firebaseCompat.auth().signOut();
    })
    .then(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    })
    .catch((err) => {
      this.setState({
        error: 'Invalid or expired link.',
        loading: false,
      });
      window.history.replaceState({}, document.title, window.location.pathname);
    });

  return;
}
  // NO GLOBAL AUTO-SIGNOUT LISTENER
  // Removed — it was logging users out after password login
}

handlePasswordReset = () => {
  const { newPassword, confirmPassword, resetOobCode } = this.state;

  if (newPassword !== confirmPassword) {
    this.setState({ error: 'Passwords do not match.' });
    return;
  }

  if (newPassword.length < 6) {
    this.setState({ error: 'Password must be at least 6 characters long.' });
    return;
  }

  this.setState({ loading: true, error: '', message: 'Updating password...' });

  firebaseCompat.auth()
    .confirmPasswordReset(resetOobCode, newPassword)
    .then(() => {
      this.setState({
        message: 'Password successfully reset! You can now log in with your new password.',
        showPasswordResetForm: false,
        loading: false,
        newPassword: '',
        confirmPassword: ''
      });
      // Clean URL again
      window.history.replaceState({}, document.title, window.location.pathname);
    })
    .catch((error) => {
      let msg = 'Failed to reset password.';
      if (error.code === 'auth/weak-password') msg = 'Password is too weak.';
      this.setState({
        error: msg,
        loading: false
      });
    });
};

handleConfirmEmail = () => {
    if (this.state.isSubmitting_confirmEmail) return;
    this.setState({ isSubmitting_confirmEmail: true });

  const email = this.state.username.trim();
  if (!email || !email.includes('@')) {
    this.setState({ error: 'Please enter a valid email address' });
    return;
  }

  this.setState({ loading: true, error: '', message: '' });

  const actionCodeSettings = {
    // Use the current full URL *without* any existing query params
    url: window.location.origin + window.location.pathname,
    handleCodeInApp: true,
  };

  firebaseCompat.auth().sendSignInLinkToEmail(email, actionCodeSettings)
    .then(() => {
      localStorage.setItem('emailForSignIn', email);
      this.setState({
        message: 'Confirmation link sent! Check your email (including spam).',
        loading: false,
      });
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'success',
        message: 'A confirmation Email was sent to your inbox.',
      });
    })
    .catch((error) => {
      console.error('Send link error:', error);
      this.setState({ 
        error: error.message || 'Failed to send link. Try again.',
        loading: false 
      });
    });
};

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value.trim() });
  };

  // Check lockout status for current email
  checkLockoutStatus = async (email) => {
    if (!email) return;
    
    try {
      // Get user's phone number
      const phoneNumber = await this.props.getUserPhoneNumber(email);
      if (!phoneNumber) return;
      
      // Check lockout status
      const lockoutStatus = await this.props.checkOTPLockoutStatus(phoneNumber);
      
      // Update state with current lockout information
      this.setState({
        lockoutCount: lockoutStatus.lockoutCount || 0,
        needsEscalation: lockoutStatus.needsEscalation || false
      });
      
    } catch (error) {
      
    }
  }

  // Load user's default security level from localStorage or user profile
  loadUserSecurityPreference = async () => {
    try {
      // Check if user is logged in
      const userdata = JSON.parse(localStorage.getItem('USER_LOGGED_IN') || '{}');
      
      if (userdata.uid) {
        // Load from user profile in Firebase
        const userRef = firebase.database.ref(`/user/${userdata.uid}`);
        const snapshot = await userRef.once('value');
        
        if (snapshot.exists()) {
          const userData = snapshot.val();
          const profileSecurityLevel = userData.defaultSecurityLevel || 'level1';
          const hasValidPhone = userData.cellphone && userData.cellphone.trim() !== '';
          
          // Validate Level 2 requirements (phone number previously used for WhatsApp OTP)
          if (profileSecurityLevel === 'level2' && !hasValidPhone) {
    
            this.setState({ 
              securityLevel: 'level1',
              showSecuritySelector: true,
              phoneNumberStatus: 'missing'
            });
            // Update profile to Level 1
            this.updateUserWhatsAppOTPSetting(userdata.uid, false, 'level1');
          } else if (profileSecurityLevel === 'level3' && !hasValidPhone) {
    
            this.setState({ 
              securityLevel: 'level1',
              showSecuritySelector: true,
              phoneNumberStatus: 'missing'
            });
            // Update profile to Level 1
            this.updateUserWhatsAppOTPSetting(userdata.uid, false, 'level1');
          } else {
            this.setState({ 
              securityLevel: profileSecurityLevel,
              showSecuritySelector: true,
              phoneNumberStatus: hasValidPhone ? 'valid' : 'missing',
              phoneNumber: userData.cellphone || ''
            });
            
      // Ensure legacy WhatsApp OTP setting matches security level (kept for backwards compatibility)
            const expectedOTPSetting = (profileSecurityLevel === 'level2' || profileSecurityLevel === 'level3') && hasValidPhone;
            if (userData.receiveWhatsAppSecurity !== expectedOTPSetting) {
              this.updateUserWhatsAppOTPSetting(userdata.uid, expectedOTPSetting, profileSecurityLevel);
            }
          }
          return;
        }
      }
      
      // Fallback to localStorage if no user profile
      const storedSecurityLevel = localStorage.getItem('userSecurityLevel');
      if (storedSecurityLevel && (storedSecurityLevel === 'level1' || storedSecurityLevel === 'level2' || storedSecurityLevel === 'level3')) {

        this.setState({ 
          securityLevel: storedSecurityLevel,
          showSecuritySelector: true,
          phoneNumberStatus: (storedSecurityLevel === 'level2' || storedSecurityLevel === 'level3') ? 'missing' : 'valid'
        });
      } else {
        // Default to Level 2 but check for phone number
        this.setState({ 
          securityLevel: 'level1',
          showSecuritySelector: true,
          phoneNumberStatus: 'missing'
        });
      }
    } catch (error) {
      
      // Default to Level 2 on error
              this.setState({ 
          securityLevel: 'level1',
        showSecuritySelector: true,
        phoneNumberStatus: 'missing'
      });
    }
  };

  // Save user's security level preference and update legacy WhatsApp OTP settings
  saveUserSecurityPreference = (securityLevel) => {
    try {
      // Save to localStorage
      localStorage.setItem('userSecurityLevel', securityLevel);
      
      // If user is logged in, update their profile settings
      const userdata = JSON.parse(localStorage.getItem('USER_LOGGED_IN') || '{}');
      
      if (userdata.uid) {
        // Check if user has a valid phone number for Level 2 and Level 3
        if (securityLevel === 'level2' || securityLevel === 'level3') {
          this.checkAndEnableWhatsAppOTP(userdata.uid, securityLevel);
        } else {
          // Level 1: Disable WhatsApp OTP
          this.updateUserWhatsAppOTPSetting(userdata.uid, false, securityLevel);
        }
      }
      

    } catch (error) {
      
    }
  };

  // Check user's phone number and enable WhatsApp OTP for Level 2
  checkAndEnableWhatsAppOTP = async (uid, securityLevel) => {
    try {
      // Get user's profile to check phone number
      const userRef = firebase.database.ref(`/user/${uid}`);
      const snapshot = await userRef.once('value');
      
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const hasValidPhone = userData.cellphone && userData.cellphone.trim() !== '';
        
        if (hasValidPhone) {
          // Enable WhatsApp OTP for Level 2 and Level 3 (legacy – retained for backwards compatibility)
          this.updateUserWhatsAppOTPSetting(uid, true, securityLevel);
          
          this.setState({
            securityLevel: securityLevel,
            phoneNumberStatus: 'valid',
            phoneNumber: userData.cellphone
          });
        } else {
          // User doesn't have phone number - show warning and fallback to Level 1
          const levelText = securityLevel === 'level2' ? 'Level 2' : securityLevel === 'level3' ? 'Level 3' : 'Enhanced';
          alert(`⚠️ PHONE NUMBER REQUIRED\n\n${levelText} security requires a valid phone number in your profile.\n\nPlease add your phone number in Profile Settings, or use Level 1 for now.`);
          
          this.setState({
            securityLevel: 'level1',
            phoneNumberStatus: 'missing'
          });
          
          // Save Level 1 instead
          localStorage.setItem('userSecurityLevel', 'level1');
        }
      }
    } catch (error) {
      
      // Fallback to Level 1 on error
      this.setState({ securityLevel: 'level1' });
    }
  };

  // Update user's WhatsApp OTP setting in Firebase
  updateUserWhatsAppOTPSetting = async (uid, enableOTP, securityLevel) => {
    try {
      const updates = {
        receiveWhatsAppSecurity: enableOTP,
        defaultSecurityLevel: securityLevel,
        lastSecurityUpdate: Date.now()
      };
      
      // Update both user paths in Firebase
      await firebase.database.ref(`/user/${uid}`).update(updates);
      
      // Also update in users collection if it exists
      const usersRef = firebase.database.ref('/users');
      const usersSnapshot = await usersRef.orderByChild('uid').equalTo(uid).once('value');
      
      if (usersSnapshot.exists()) {
        const usersData = usersSnapshot.val();
        const userKey = Object.keys(usersData)[0];
        await firebase.database.ref(`/users/${userKey}`).update(updates);
      }
      

      
      // Show confirmation message
      const otpStatus = enableOTP ? 'enabled' : 'disabled';
      const levelName = securityLevel === 'level1' ? 'Level 1 (Standard)' : securityLevel === 'level2' ? 'Level 2 (Secure)' : securityLevel === 'level3' ? 'Level 3 (Maximum)' : 'Enhanced Security';
      
      if (enableOTP) {
        this.props.showMessage({
          type: 'success',
          message: `🛡️ Security updated to ${levelName}\nTwo-factor authentication is enabled for enhanced security.`
        });
      } else {
        this.props.showMessage({
          type: 'info',
          message: `⚡ Security updated to ${levelName}\nTwo-factor authentication is disabled for faster login.`
        });
      }
      
    } catch (error) {
      
    }
  };

  filterZZZ = (comLable) => {
    let comLablex = comLable.toString()
    let myTruncatedString = comLablex.substring(0, 4)
    let finalstring = comLablex

    if (myTruncatedString === 'ZZZ_') {
      finalstring = comLablex.substring(4, comLablex.length)
    }
    if (myTruncatedString === 'AAA_') {
      finalstring = comLablex.substring(4, comLablex.length)
    }
    return finalstring
  };

  renderGeneralSettings = (type) => {
    
    let itemdata = null;
    
    // First try to get from props
    if (this.props.general_settings && this.props.general_settings[type]) {
      itemdata = this.props.general_settings[type];
      
    } else {
      // No fallback: show empty state when DB has no values
      itemdata = [];
      
    }
    
    if (itemdata && itemdata.length > 0) {
      return itemdata.map((v, i) => (
        <MenuItem key={i} value={v}>
          {v}
        </MenuItem>
      ));
    } else {
      
      return [
        <MenuItem key="no-data" value="" disabled>
          No {type} options available
        </MenuItem>
      ];
    }
  };

  renderCompanySettings = (type) => {
    let itemdata = null


    if (this.props.company_settings && this.props.company_settings[type]) {
      itemdata = this.props.company_settings[type];
      itemdata.sort()
      return itemdata.map((v, i) => (
        <MenuItem key={i} value={v}>
          {this.filterZZZ(v)}
        </MenuItem>
      ))
    }
  };

  // Load user's security preference by email before login
  loadSecurityPreferenceByEmail = async (email) => {
    try {
      console.log('[About.js] Loading security preference for email:', email);
      
      // Search for user by email in Firebase
      const usersRef = firebase.database.ref('/user');
      const snapshot = await usersRef.orderByChild('email').equalTo(email).once('value');
      
      if (snapshot.exists()) {
        const users = snapshot.val();
        const userKey = Object.keys(users)[0];
        const userData = users[userKey];
        
        const profileSecurityLevel = userData.defaultSecurityLevel || 'level1';
        const hasValidPhone = userData.cellphone && userData.cellphone.trim() !== '';
        const hasWhatsAppOTP = userData.receiveWhatsAppSecurity || false;
        
        console.log('[About.js] User security settings:', {
          defaultSecurityLevel: userData.defaultSecurityLevel,
          profileSecurityLevel: profileSecurityLevel,
          totpEnabled: userData.totpEnabled,
          hasTotpSecret: !!userData.totpSecret
        });

        
        // Set the security level based on what's in the user's profile
        this.setState({ 
          securityLevel: profileSecurityLevel,
          phoneNumber: userData.cellphone || '',
          phoneNumberStatus: hasValidPhone ? 'valid' : 'missing'
        });
        
        return profileSecurityLevel;
      } else {

        // If no user found, default to level1
        this.setState({ securityLevel: 'level1' });
        return 'level1';
      }
    } catch (error) {
      
      this.setState({ securityLevel: 'level1' });
      return 'level1';
    }
  };

  checkEmailConfirmationStatus = async (email) => {
    if (!email) return null;

    const safeEmail = email.replace(/\./g, '_');

  //  const userRef = ref(database, `/emailconfirmations/${safeEmail}`);

    let database = firebase.database;
    let refPath = `/emailconfirmations/${safeEmail}`;

    try {
      const snapshot = await database.ref(refPath).once('value');

      if (snapshot.exists()) {
        const data = snapshot.val();
        return data.status; // returns true, false, or undefined if missing
      } else {
        return null; // user not found in emailconfirmations
      }
    } catch (error) {
      console.error("Error reading email confirmation status:", error);
      return null;
    }
  };

  signInEmailx = async () => {
    if (this.state.showEmailVerification) {
      if (!this.state.emailVerificationToken || this.state.emailVerificationToken.length < 10) {
        alert('Please enter the verification token from your email.');
        return;
      }
      this.setState({ loading: true });
      this.props.showLoader({ type: SHOW_LOADER });
      
      this.props.verifyEmailBypassToken(this.state.username, this.state.emailVerificationToken)
        .then(result => {
          if (result.success) {
            // Reset states and allow normal login
            this.setState({
              showEmailVerification: false,
              needsEscalation: false,
              emailVerificationToken: '',
              lockoutCount: 0,
              showOtpField: false,
              otpSent: false,
              otp: ''
            });
          }
        })
        .catch(error => {
          
        });
      return;
    }
    
    if (!this.state.showOtpField) {
      // First step: Send OTP or login directly based on device trust and security level
      if (!this.state.username || !this.state.userpassword) {
        return;
      }
      
      this.props.showLoader({ type: SHOW_LOADER })
      
      // Only on Live server
      if (SERVER_TYPE === 'LIVE') {
        // this.checkUserDomain(this.state.username)
      }
      
      // IMPORTANT: Load user's actual security preference before login
      const actualSecurityLevel = await this.loadSecurityPreferenceByEmail(this.state.username);
      
      // Use enhanced authentication with device trust
      
      const cleanedState = trimAllStrings(this.state);
      

      
      console.log('[About.js] Calling signInEmailEnhanced with securityLevel:', actualSecurityLevel);
      
      this.props.signInEmailEnhanced({
        ...JSON.parse(JSON.stringify(cleanedState)),
        securityLevel: actualSecurityLevel
      })
        .then(result => {
          console.log('[About.js] signInEmailEnhanced result:', result);
          
          if (result && result.success && result.requiresOTP) {
            // TOTP required - show code field
            console.log('[About.js] TOTP required - showing OTP field');
            this.setState({
              showOtpField: true,
              otpSent: false,
              otpMethod: 'totp'
            });
          } else if (result && result.success && !result.requiresOTP) {
            // Login successful without OTP (trusted device or Level 1)
            console.log('[About.js] Login successful without OTP');

          } else if (result && result.isLocked && result.needsEscalation) {
            // Handle escalation - multiple lockouts detected  
            this.setState({
              needsEscalation: true,
              lockoutCount: result.lockoutCount || 0,
              showOtpField: false,
              otpSent: false
            });
            
            // Show specific message for multiple lockouts
            this.props.showToast({
              type: 'SHOW_TOAST',
              open: true,
              variant: 'error',
              message: 'Multiple security lockouts detected. Please use Account Recovery to regain access.',
            });
          }
        })
        .catch(error => {
          
          if (error.needsEscalation) {
            this.setState({
              needsEscalation: true,
              lockoutCount: error.lockoutCount || 0,
              showOtpField: false,
              otpSent: false
            });
            
            // Show specific message for multiple lockouts
            this.props.showToast({
              type: 'SHOW_TOAST',
              open: true,
              variant: 'error',
              message: 'Multiple security lockouts detected. Please use Account Recovery to regain access.',
            });
          }
        });
        
      } else {
        // Second step: Verify OTP (only for Level 2)
        if (!this.state.otp || this.state.otp.length !== 6) {
          return;
        }
        
        this.props.showLoader({ type: SHOW_LOADER })

        // ── TEMP DIAGNOSTIC ──
        const t0 = Date.now();
        const setStatus = (msg) => {
          this.setState({ totpTimingStatus: `${Math.round((Date.now()-t0)/100)/10}s: ${msg}` });
        };
        setStatus('Starting verification...');
        // ── END TEMP DIAGNOSTIC ──
        
        // Include OTP in login data and use enhanced authentication
        const loginData = {
          ...trimAllStrings(this.state),
          otp: this.state.otp,
          securityLevel: this.state.securityLevel,
          onStatus: setStatus  // ← ADD
        };
        
        this.props.signInEmailEnhanced(loginData)
        .then(result => {
          if (result && result.success) {
            // Login successful - clear any lockout states
            this.setState({
              needsEscalation: false,
              lockoutCount: 0,
              showOtpField: false,
              otpSent: false
            });
          } else if (result && (result.needsEscalation || result.lockoutCount >= 3)) {
            // Handle escalation from OTP verification
            this.setState({
              needsEscalation: true,
              lockoutCount: result.lockoutCount || 0,
              showOtpField: false,
              otpSent: false
            });
            
            this.props.showToast({
              type: 'SHOW_TOAST',
              open: true,
              variant: 'error',
              message: 'Multiple security lockouts detected. Please use Account Recovery to regain access.',
            });
          } else if (result && result.isLocked) {
            // Regular lockout (not escalation yet)
            this.setState({
              lockoutCount: result.lockoutCount || 0
            });
          }
        })
        .catch(error => {
          
          
          if (error.needsEscalation || (error.lockoutCount && error.lockoutCount >= 3)) {
            this.setState({
              needsEscalation: true,
              lockoutCount: error.lockoutCount || 0,
              showOtpField: false,
              otpSent: false
            });
            
            // Show specific message for multiple lockouts  
            this.props.showToast({
              type: 'SHOW_TOAST',
              open: true,
              variant: 'error',
              message: 'Multiple security lockouts detected. Please use Account Recovery to regain access.',
            });
          } else if (error.lockoutCount) {
            // Update lockout count even if not escalation yet
            this.setState({
              lockoutCount: error.lockoutCount || 0
            });
          }
        });
    }
  };

  handlePressEnter = async(event) => {
    if (event.key === 'Enter') {
      this.signInEmailx(event)
      // this.props.signInEmail(this.state);
    }
  }

  handleClose = () => {
    this.setState({
      ...this.state,
      open: false
    })
  };

  handleCloseTandC = () => {
    this.setState({
      ...this.state,
      openTandC: false
    })
  };


  handleClosePolicy = () => {
    this.setState({
      ...this.state,
      open: false,
      openPolicy: false
    })
  };

  handleViewTermsAndConditions = () => {
    this.setState({
      ...this.state,
      openTandC: true
    })
  };


  handleViewPolicy = () => {
    this.setState({
      ...this.state,
      open: false,
      openPolicy: true
    })
  };

  // ---------------
  handleChange = prop => event => {
    
    
    this.setState({
      [prop]: event.target.value
    });
    
    // Check lockout status when email is entered or changed
    if (prop === 'username' && event.target.value && event.target.value.includes('@')) {
     this.setState({ email: event.target.value.trim() });
      setTimeout(() => {
        this.checkLockoutStatus(event.target.value);
      }, 500); // Small delay to avoid too many calls
    }
  };

  handlePass = prop => event => {
    this.setState({
      password: 'DefaultPassword123*'
    })
  };

  // ---------------
  handleChecked = prop => event => {
    if (this.state.selectClub) { //person followed link given by other user
        let clubName
        switch (this.state.selectClub) {
        case '-LjW7UI7e0uUikYrw-Vj':
          clubName = 'ThinkLead Ecosystem'
          break
        case '-NRbTwxbqFLepk62Eq6M':
          clubName = 'MeVision'
            break  
        case '-MHRD2gH8B-4umEza1eG':
          clubName = 'ActionSA South Africa'
          break
        case '-M4LtrI17CY5H1Krhi5J':
          clubName = 'Towerstone South Africa'
          break
        case '-Lr8gaCje_jeM5RVUauP':
          clubName = 'Texas USA Accountability Cop'
          break
        case '-LoacuJOqQP7sZU7_sFQ':
          clubName = 'GLI in Canada'
          break
        case '-MZwJp46RoDtehNEGly3':
          clubName = 'Leadership Express Nigeria'
          break
        case '-MRZC7xU_69moSco5_sX':
          clubName = 'ThinkLead Power Sector'
          break
        default:
          clubName = 'Public Ecosystem'
        }
        this.setState({ clubName: clubName })
      }
    
    this.setState({
      [prop]: event.target.checked
    })
  };

  handleToggleLoginSignUp = () => {
    this.setState({ showLogin: !this.state.showLogin })
  }
  // ---------------
  signInGoogle = async () => {
   if (this.state.isSubmitting_signInGoogle) return;
    this.setState({ isSubmitting_signInGoogle: true });

   const selectC = this.state.selectClub;
    this.props.showLoader({ type: SHOW_LOADER });

    if (this.state.showLogin) { //is login page
      // No email pre-check. Google email will be validated after popup; unknown users are blocked and cleaned up.
      await this.props.signGoogle(undefined);
    } else { //is signUp page
      
      if (this.state.agreeTCs) { 
        

        // For Google signup, pass minimal data - name and email come from Google
        const signupData = {
          selectClub: this.state.selectClub,
          clubName: this.state.clubName,
          // Optional fields - use if filled, otherwise defaults will be used
          position: this.state.position || '', 
          department: this.state.department || '', 
          nationality: this.state.nationality || '', 
          agreeTCs: this.state.agreeTCs,
          // Pass state for Google login to handle
          isSignup: true
        };
        
        
        await this.props.signGoogle(signupData);
     }
     else{
       let params = {
         type: SHOW_TOAST,
         open: true,
         variant: 'warning',
         message: 'Please agree to the ThinkLead Terms and Conditions.',
         pos: 'top'
       }
       this.props.showToast(params)
     }
    }

  };

  // ---------------
SignUpWithEmail = e => {
  e.preventDefault();
   if (this.state.isSubmitting_SignUpWithEmail) return;
    this.setState({ isSubmitting_SignUpWithEmail: true });

  if (!this.state.agreeTCs) {
    this.props.showToast({
      type: SHOW_TOAST,
      open: true,
      variant: 'warning',
      message: 'Please agree to the ThinkLead Terms and Conditions.',
      pos: 'top'
    });
    return;
  }

  const email = (this.state.username || '').trim();
  const password = (this.state.password || '').trim();
  const userpassword = (this.state.userpassword || '').trim();

  if (!email || !password) {
    this.props.showToast({
      type: SHOW_TOAST,
      open: true,
      variant: 'error',
      message: 'Email and password are required.',
      pos: 'top'
    });
    return;
  }

  // === MATCH BACKEND STRUCTURE: wrap everything in "params" ===
  const payloadForBackend = {
    params: {
      email: email,
      password: password ? password : userpassword,
      firstName: (this.state.firstName || '').trim(),
      lastName: (this.state.lastName || '').trim(),
      selectClub: this.state.selectClub || '-NRbTwxbqFLepk62Eq6M',
      clubName: this.state.clubName || 'Me-Vision Academy',
      department: (this.state.department || '').trim(),
      position: (this.state.position || '').trim(),
      nationality: (this.state.nationality || '').trim(),
      agreeTCs: true,
      pendingLinkToken: this.state.pendingLinkToken || localStorage.getItem('pendingLinkToken') || '', // ← add this
    }
  };

  console.log('PAYLOAD SENT TO BACKEND (with params wrapper):', payloadForBackend);

  this.props.SignUpWithEmail(payloadForBackend);
};

  handleSubmitUserxx = userData => {
    }

  handleSubmitUserx = e => {
    e.preventDefault()
    let params = {
      email: this.state.email,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      companyID: this.state.selectClub,
      companyName: this.state.clubName,
      userType: 3,
      selectedCategory: 3,
      gender: 'x',
      points: 1,
      race: 'x',
      position: 'x',
      nationality: 'x',
      idNumber: '555',
      department: 'x',
      feedback: 0,
      feedbackOn: true,
      LeaderboardKey: this.state.selectClub + '_' + 'x' + '_' + 'x' + '_' + 'x'
    }
    this.props.checkUserIs(params, () => {
      this.props.createCompanyUser(params)
    }, () => {
      })
    // this.props.checkUserIs(this.state);
  };

  // ---------------
  checkUserDomain = usr => {
    let url = window.location.origin

    let corporates = [
      'edcon.co.za',
      'edcon@',
      'oneconnect.co.za',
      'oneconnect@',
      // 'blsa.org.za',
      // 'blsa@',
      // 'businessleadership.org.za',
      'harmony@',
      'harmony.thinklead.co.za',
      'harmony.co.za'
      // 'businessleadership@'
    ]

    for (let x = 0; x < corporates.length; x++) {
      let y = corporates[x]
      let patt = new RegExp(y)

      if (patt.test(usr)) {
        let corporateDomains = {
          'oneconnect.co.za': 'https://oneconnect.thinklead.co.za',
          'oneconnect@': 'https://oneconnect.thinklead.co.za',
          'edcon.co.za': 'https://edcon.thinklead.co.za',
          'edcon@': 'https://edcon.thinklead.co.za',
          // 'blsa.org.za': 'https://blsa.thinklead.co.za',
          // 'blsa@': 'https://blsa.thinklead.co.za',
          'harmony@': 'https://harmony.thinklead.co.za',
          'harmony.thinklead.co.za': 'https://harmony.thinklead.co.za',
          'harmony.co.za': 'https://harmony.thinklead.co.za'
          // 'businessleadership.org.za': 'https://blsa.thinklead.co.za',
          // 'businessleadership@': 'https://blsa.thinklead.co.za'
        }

        let companyurl = corporateDomains[y]

        if (url !== companyurl) {
          window.location.replace(companyurl)
        }
      }
    }
  };

  // ---------------
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  };

  // ---------------
  resetPassword = e => {
    e.preventDefault()

    this.props.resetPassword({
      email: this.state.email,
      actionCodeSettings: {
        url: window.location.origin
      }
    })
  };


  // Open support page
  openSupportPage = () => {
    const email = encodeURIComponent(this.state.username || '');
    const lockoutCount = this.state.lockoutCount || 3;
    window.open(`/support-contact?email=${email}&lockout=${lockoutCount}`, '_blank');
  };

  showVideo = () => {
    let coverPageTextMargin = window.innerWidth < 600 ? coverPageTextDivSm : coverPageTextDiv
    let ImgLogoMargin = window.innerWidth < 600 ? ImgLogoSm : ImgLogo

    return (
      <div className='player-wrapper'>
        <img src={logo} style={ImgLogoMargin} />
        <div style={coverPageTextMargin}>
          <Typography variant='h5' style={coverPageHeader}>
            Welcome to ThinkLead<sup>&reg;</sup>. One platform for all things leadership
          </Typography>
          <Typography variant='h5' style={coverPageText}>
            <span style={coverPagePoints}>We-Lead Forum - </span>a collaboration hub to connect a global leadership community
          </Typography>
          <Typography variant='h5' style={coverPageText}>
            <span style={coverPagePoints}>I-Learn Library - </span>a resource centre for leadership knowledge
          </Typography>
          <Typography variant='h5' style={coverPageText}>
            <span style={coverPagePoints}>I-Lead Toolkit - </span>a self-development area to build positive habits
          </Typography>
        </div>

      </div>
    )
  }

  showThinkLeadVideo = () => {
    return (
      <Media query='(min-width: 960px)'>
        {matches =>
          matches ? (
            this.showVideo('65vh')
          ) : (
            this.showVideo('32vh')
          )
        }
      </Media>
    )
  }

  showHarmonyImg = () => {
    return (
      <div>
        <img src={harmonyImg} style={{ width: '98%' }} />
      </div>
    )
  }
  handleClubChange = (e) => {
    let clubName
    switch (e.target.value) {
    case '-LjW7UI7e0uUikYrw-Vj':
      clubName = 'ThinkLead Ecosystem'
      break
    case '-MHRD2gH8B-4umEza1eG':
      clubName = 'ActionSA South Africa'
      break
    case '-M4LtrI17CY5H1Krhi5J':
      clubName = 'Towerstone South Africa'
      break
    case '-Lr8gaCje_jeM5RVUauP':
      clubName = 'Texas USA Accountability Cop'
      break
    case '-LoacuJOqQP7sZU7_sFQ':
      clubName = 'GLI in Canada'
      break
    case '-MZwJp46RoDtehNEGly3':
      clubName = 'Leadership Express Nigeria'
      break
    case '-MRZC7xU_69moSco5_sX':
      clubName = 'ThinkLead Power Sector'
      break
    default:
      clubName = 'Public Ecosystem'
    }

    this.setState({ selectClub: e.target.value })
    this.setState({ clubName: clubName })
  }

  handleMouseOver = (club) => {
    let clubName
    let clubProfile = ''

    switch (club) {
    case '-LjW7UI7e0uUikYrw-Vj':
      clubName = 'ThinkLead Ecosystem'
      clubProfile = 'Creating Personal Leadership for any individual leader across the globe'
      break
    case '-Mci2tVbY406VWKWa5Ov':
      clubName = 'The Book Every Leader Needs to Read'
      clubProfile = 'Pages & pages of mentorship'
      break
    case '-MHRD2gH8B-4umEza1eG':
      clubName = 'ActionSA South Africa'
      clubProfile = ''
      break
    case '-M4LtrI17CY5H1Krhi5J':
      clubName = 'Towerstone South Africa'
      clubProfile = ''
      break
    case '-Lr8gaCje_jeM5RVUauP':
      clubName = 'Texas USA Accountability Cop'
      clubProfile = ''
      break
    case '-LoacuJOqQP7sZU7_sFQ':
      clubName = 'GLI in Canada'
      clubProfile = ''
      break
    case '-MZwJp46RoDtehNEGly3':
      clubName = 'Leadership Express Nigeria'
      clubProfile = 'Creating Personal Leadership for leaders in Nigeria & beyond'
      break
    case '-MRZC7xU_69moSco5_sX':
      clubName = 'ThinkLead Power Sector'
      clubProfile = 'Creating Personal Leadership inside the Power Sector'
      break
    case '-NRbTwxbqFLepk62Eq6M':
      clubName = 'Adrian Groenewald'
      clubProfile = 'Creating Personal Leadership'
      break  
    default:
      clubName = 'Public Ecosystem'
      clubProfile = ''
    }
    let params = {
      type: SHOW_TOAST,
      open: true,
      variant: 'success',
      message: clubProfile,
      pos: 'bottom'
    }
    this.props.showToast(params)

     //this.setState({selectClub: e.target.value});
     this.setState({clubName: clubName});
  }

  // Handle email verification request for escalated users
  requestEmailVerification = () => {
    if (!this.state.username) {
      alert('Please enter your email address first.');
      return;
    }
    
    this.props.showLoader({ type: SHOW_LOADER });
    
    this.props.sendEmailVerificationBypass(this.state.username)
      .then(result => {
        if (result.success) {
          this.setState({
            showEmailVerification: true,
            // For development - show the token (remove in production)
            emailVerificationToken: result.verificationToken || ''
          });
        }
      })
      .catch(error => {
        
      });
  };

  // Show support contact information
  showSupportContact = () => {
    const supportMessage = `🆘 CONTACT SUPPORT\n\nAccount: ${this.state.username}\nIssue: Multiple security lockouts\nLockout Count: ${this.state.lockoutCount}\n\n📧 Email: support@mevisionacademy.com\n📞 Phone: +27 123 456 789\n💬 WhatsApp: +27 123 456 789\n\nPlease include your email address and mention "Security Lockout Escalation" in your message.`;
    
    alert(supportMessage);
    
    // Copy email to clipboard for easy access
    if (navigator.clipboard) {
      navigator.clipboard.writeText('support@mevisionacademy.com')
        .then(() => {
          
        })
        .catch(err => {
          
        });
    }
  };

  // Show phone number requirement message for Level 2
  showPhoneNumberRequirement = () => {
    const message = `📱 PHONE NUMBER PREVIOUSLY REQUIRED FOR WHATSAPP OTP\n\nLegacy Level 2 security mentioned WhatsApp OTP. The recommended method now is Google Authenticator (TOTP).\n\nIf you see this message, please enable TOTP in your Security settings for stronger protection, or use Level 1 for standard email/password login.`;
    
    alert(message);
  };



  // Redirect to account recovery page for users with 3+ lockouts
  redirectToAccountRecovery = () => {
    const email = this.state.username;
    if (!email) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: '⚠️ Please enter your email address.',
      });
      return;
    }
    
    // Construct the support URL with lockout parameters
    const supportUrl = `${window.location.origin}/support-contact?email=${encodeURIComponent(email)}&lockout=3`;
    
    this.props.showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'info',
      message: '🔗 Redirecting to Account Recovery page...',
    });
    
    // Redirect to account recovery page
    setTimeout(() => {
      window.location.href = supportUrl;
    }, 1000);
  };

render(props) {
  const {
    firstName,
    lastName,
    email,
    password,
    showPassword,
    agreeTCs,
    directJoin,
    message, 
    error, 
    loading, 
    verifieduser,
    setEmail 
  } = this.state

    const currentEmail = this.state.username || email || '';

const isInvalid =
  password.trim().length < 6 ||   // ← Change from 7 to 6
  password === '' ||
  currentEmail.trim() === '' ||
  firstName.trim() === '' ||
  lastName.trim() === '' ||
  !agreeTCs;

  const isSignupInvalid = isInvalid;

  console.log('verifystate: verifieduser 2: ', this.state.verifieduser);
  console.log('verifystate: setEmail 2: ', this.state.setEmail);
  console.log('verifystate: showLogin 2: ', this.state.showLogin);

  const { classes, showprogress } = this.props

  if (window.location.href.includes('harmony')) {
    this.state.isHarmony = true
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.pageWrap}>
      <Container maxWidth='lg' style={{ padding: 0 }}>
        <Grid container className={classes.authShell}>
          <Hidden smDown>
          <Grid item xs={12} sm={5} md={5} className={classes.brandPanel}>
              {/* <img src={mevImage} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center top' }} alt="Updated Image"/> */}
        <div className={classes.brandOverlay}>
          <div className={classes.brandLogoRow}>
        <img
          src={dennisLogo}
          alt="Dennis — Powered by Me-Vision"
          style={{ width: '100%', height: 'auto', borderRadius: 8 }}
        />
          </div>

        <div>
          <Typography variant='h4' className={classes.brandHeading}>
            Develop. Be tested. Be certified.
          </Typography>
      <Typography className={classes.brandSub}>
       Dennis is a Super Development Partner — the full strength of frontier AI pointed at you, not at your tasks. He works on your judgement, your character, capability and wisdom. Then he tests you, and certifies who you have become. Level by level.
      </Typography>
          <div className={classes.brandBadgeRow}>
            <span className={classes.brandBadge}>Start with Dennis</span>
            <span className={classes.brandBadge}>For your school</span>
            <span className={classes.brandBadge}>For your organisation</span>
          </div>
        </div>
      </div>
          </Grid>
          </Hidden>

          {/* === MAIN CONDITIONAL: PASSWORD RESET > LOGIN > SIGNUP === */}
          {this.state.showPasswordResetForm ? (
            /* ==================== PASSWORD RESET FORM ==================== */
            <Grid item xs={12} sm={7} md={7} className={classes.formPanel}>
              <Media queries={{ small: '(max-width: 599px)' }}>
                {matches => matches.small ? <img src={ThinkLeadLogo} style={{ width: '100%', height: 'auto', borderRadius: FIELD_RADIUS, marginBottom: 24 }} /> : null}
              </Media>

              <Typography className={classes.formEyebrow}>ACCOUNT SECURITY</Typography>
              <Typography variant="h5" className={classes.formHeading}>
                Reset your password
              </Typography>
              <Typography className={classes.formSubtext}>
                Choose a new password to get back into your ThinkLead account.
              </Typography>

              {this.state.message && (
                <Typography variant="body1" style={{ marginBottom: '15px', color: '#1976d2' }}>
                  {this.state.message}
                </Typography>
              )}

              {this.state.error && (
                <Typography color="error" style={{ marginBottom: '15px' }}>
                  {this.state.error}
                </Typography>
              )}

              <TextField
                variant='outlined'
                margin='dense'
                placeholder='New Password (min 6 characters)'
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.state.newPassword || ''}
                onChange={this.handleChange('newPassword')}
                fullWidth
                style={{ backgroundColor: '#fff', borderRadius: FIELD_RADIUS, marginBottom: 14 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton onClick={this.handleClickShowPassword}>
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />

              <TextField
                variant='outlined'
                margin='dense'
                placeholder='Confirm New Password'
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.state.confirmPassword || ''}
                onChange={this.handleChange('confirmPassword')}
                fullWidth
                onKeyDown={(e) => e.key === 'Enter' && this.handlePasswordReset()}
                style={{ backgroundColor: '#fff', borderRadius: FIELD_RADIUS }}
              />

              <Button
                variant='contained'
                onClick={this.handlePasswordReset}
                disabled={this.state.loading}  // COMMENT OUT LOCAL HOST
                fullWidth
                className={classes.button}
                style={{ marginTop: '22px', height: '50px' }}
              >
                {this.state.loading ? 'Updating Password...' : 'Set New Password'}
              </Button>

              <Button
                variant='text'
                onClick={() => {
                  this.setState({
                    showPasswordResetForm: false,
                    message: '',
                    error: '',
                    newPassword: '',
                    confirmPassword: ''
                  });
                  window.history.replaceState({}, document.title, window.location.pathname);
                }}
                fullWidth
                style={{ marginTop: '10px', color: '#667085', textTransform: 'none' }}
              >
                Back to Login
              </Button>
            </Grid>
          ) : this.state.showLogin ? (
            /* ==================== ORIGINAL LOGIN FORM (100% UNCHANGED) ==================== */
            <Grid item xs={12} sm={7} md={7} className={classes.formPanel}>
              <Media queries={{ small: '(max-width: 599px)' }}>
                {matches =>
                  matches.small ?
                    <img src={ThinkLeadLogo} style={{ width: '100%', height: 'auto', borderRadius: FIELD_RADIUS, marginBottom: 24 }} />
                    : null
                }
              </Media>

              <Typography className={classes.formEyebrow}>WELCOME BACK</Typography>
              <Typography variant="h5" className={classes.formHeading}>
                Sign in
              </Typography>
              <Typography className={classes.formSubtext}>
                Dennis is waiting where you left off.
              </Typography>

              <TextField
                key="email-field"
                variant='outlined'
                margin='dense'
                value={this.state.username}
                placeholder={'Email Address'}
                disabled={!setEmail}  // COMMENT OUT LOCAL HOST
                fullWidth='true'
                onChange={this.handleChange('username')}
                style={{ backgroundColor: '#ffffff', borderRadius: FIELD_RADIUS, marginBottom: 12 }}
              />          

              {/* <TextField
                id='filled-adornment-password'
                variant='outlined'
                margin='dense'
                placeholder='Password'
                value={this.state.userpassword}
                type={this.state.showPassword ? 'text' : 'password'}
                autoComplete='false'
                fullWidth='true'
      //          disabled={setEmail}
                onChange={this.handleChange('userpassword')}
                onKeyDown={this.handlePressEnter}
                style={{ backgroundColor: '#fff', borderRadius: 5 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='Toggle password visibility'
                        onClick={this.handleClickShowPassword}
                      >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility /> }
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              /> */}

              {!setEmail && (   // COMMENT OUT LOCAL HOST - EXCLAMATION MARK ONLY
                <TextField
                  id="filled-adornment-password"
                  variant="outlined"
                  margin="dense"
                  placeholder="Password"
                  value={this.state.userpassword}
                  type={this.state.showPassword ? 'text' : 'password'}
                  autoComplete="false"
                  fullWidth
                  // ← removed disabled={setEmail} because it's no longer needed
                  onChange={this.handleChange('userpassword')}
                  onKeyDown={this.handlePressEnter}
                  style={{ backgroundColor: '#fff', borderRadius: FIELD_RADIUS }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                        >
                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              )}

              <>
                {setEmail && (
                  <button
                    onClick={this.handleConfirmEmail}
                    disabled={loading}
                    style={{
                      marginTop: 10,
                      height: 44,
                      padding: '0 18px',
                      borderRadius: FIELD_RADIUS,
                      border: '1px solid #d7dcf5',
                      backgroundColor: loading ? '#f1f2f8' : '#ffffff',
                      color: '#1025a2',
                      fontWeight: 600,
                      fontSize: '0.9rem',
                      cursor: loading ? 'default' : 'pointer'
                    }}
                  >
                    {loading ? 'Sending...' : 'Confirm Email'}
                  </button>
                )}
              </>

              {/* All your original conditional UI blocks remain exactly as before */}
              {this.state.securityLevel === 'level3' && !this.state.showOtpField && !this.state.needsEscalation && (
                <div style={{ margin: '12px 0', padding: '12px 14px', backgroundColor: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: FIELD_RADIUS, fontSize: '13px' }}>
                  <Typography variant="body2" style={{ color: '#1025a2', textAlign: 'center', marginBottom: '5px' }}>
                    📱 <strong>Device Trust Security</strong>
                  </Typography>
                </div>
              )}
              
            {this.state.showOtpField && (
              <>
                <TextField
                  variant='outlined'
                  margin='dense'
                  placeholder='Enter 6-digit TOTP code from Google Authenticator'
                  value={this.state.otp}
                  fullWidth='true'
                  onChange={this.handleChange('otp')}
                  onKeyDown={this.handlePressEnter}
                  style={{ backgroundColor: '#fff', borderRadius: FIELD_RADIUS, marginTop: '10px' }}
                  inputProps={{
                    maxLength: 6,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                    style: { textAlign: 'center', fontSize: '18px', letterSpacing: '2px' }
                  }}
                />
                {/* ── TEMP DIAGNOSTIC — remove after testing ── */}
                {this.state.totpTimingStatus ? (
                  <div style={{
                    marginTop: 8,
                    padding: '6px 10px',
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffc107',
                    borderRadius: 4,
                    fontSize: 12,
                    fontFamily: 'monospace',
                    wordBreak: 'break-all'
                  }}>
                    {this.state.totpTimingStatus}
                  </div>
                ) : null}
                {/* ── END TEMP DIAGNOSTIC ── */}
              </>
            )}
              
              {/* Security Escalation UI */}
              {this.state.needsEscalation && !this.state.showEmailVerification && (
                <div style={{ 
                  margin: '15px 0', 
                  padding: '20px', 
                  backgroundColor: '#fff3cd', 
                  border: '2px solid #ffc107',
                  borderRadius: '8px' 
                }}>
                  <Typography variant="h6" style={{ 
                    fontWeight: 'bold', 
                    marginBottom: '10px',
                    color: '#856404',
                    textAlign: 'center'
                  }}>
                    🚨 Security Escalation Required
                  </Typography>
                  
                  <Typography variant="body2" style={{ 
                    marginBottom: '15px',
                    color: '#856404',
                    textAlign: 'center'
                  }}>
                    Your account has been locked {this.state.lockoutCount} times due to failed login attempts.
                    For security reasons, additional verification is required.
                  </Typography>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Button
                      variant='contained'
                      onClick={this.requestEmailVerification}
                      style={{ 
                        backgroundColor: '#007bff',
                        color: 'white',
                        fontWeight: 'bold',
                        textTransform: 'none'
                      }}
                    >
                      📧 Verify via Email
                    </Button>
                    
                    <Button
                      variant='outlined'
                      onClick={this.showSupportContact}
                      style={{ 
                        borderColor: '#6c757d',
                        color: '#6c757d',
                        fontWeight: 'bold',
                        textTransform: 'none'
                      }}
                    >
                      🆘 Contact Support
                    </Button>
                    
                    <Button
                      variant='text'
                      onClick={() => {
                        this.setState({
                          needsEscalation: false,
                          showEmailVerification: false,
                          emailVerificationToken: '',
                          lockoutCount: 0
                        });
                      }}
                      style={{ 
                        color: '#6c757d',
                        fontSize: '12px',
                        textTransform: 'none'
                      }}
                    >
                      Try Different Account
                    </Button>
                  </div>
                </div>
              )}
              
              {/* Email Verification UI */}
              {this.state.showEmailVerification && (
                <div style={{ 
                  margin: '15px 0', 
                  padding: '20px', 
                  backgroundColor: '#e7f3ff', 
                  border: '2px solid #007bff',
                  borderRadius: '8px' 
                }}>
                  <Typography variant="h6" style={{ 
                    fontWeight: 'bold', 
                    marginBottom: '10px',
                    color: '#004085',
                    textAlign: 'center'
                  }}>
                    📧 Email Verification Required
                  </Typography>
                  
                  <Typography variant="body2" style={{ 
                    marginBottom: '15px',
                    color: '#004085',
                    textAlign: 'center'
                  }}>
                    A verification token has been sent to {this.state.username}.
                    Please enter the token below to regain access.
                  </Typography>
                  
                  <TextField
                    variant='outlined'
                    margin='dense'
                    placeholder='Enter verification token from email'
                    value={this.state.emailVerificationToken}
                    fullWidth='true'
                    onChange={this.handleChange('emailVerificationToken')}
                    onKeyDown={this.handlePressEnter}
                    style={{ 
                      backgroundColor: '#fff', 
                      borderRadius: 5,
                      marginBottom: '10px'
                    }}
                    inputProps={{
                      style: { 
                        textAlign: 'center', 
                        fontSize: '16px', 
                        letterSpacing: '1px' 
                      }
                    }}
                  />
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Button
                      variant='text'
                      onClick={this.requestEmailVerification}
                      style={{ 
                        color: '#007bff',
                        fontSize: '12px',
                        textTransform: 'none'
                      }}
                    >
                      Didn't receive email? Send again
                    </Button>
                    
                    <Button
                      variant='text'
                      onClick={() => {
                        this.setState({
                          showEmailVerification: false,
                          needsEscalation: true
                        });
                      }}
                      style={{ 
                        color: '#6c757d',
                        fontSize: '12px',
                        textTransform: 'none'
                      }}
                    >
                      Back to options
                    </Button>
                  </div>
                </div>
              )}
              
              <Grid container direction='row' spacing={1} style={{ marginTop: 4 }}>
                <Grid item sm={4} xl={4} xs={4}>
            <Button
              variant='contained'
              onClick={this.signInEmailx}
              className={classes.button}
              fullWidth
              disabled={setEmail}  // COMMENT OUT LOCAL HOST
            >
            {this.state.loading
              ? 'Verifying...'
              : this.state.showEmailVerification
                ? 'VERIFY EMAIL'
                : this.state.showOtpField && (this.state.securityLevel === 'level2' || this.state.securityLevel === 'level3')
                  ? 'VERIFY OTP'
                  : 'LOGIN'
            }
            </Button>
                </Grid>
                <Grid item sm={8} xl={8} xs={8}>
                  {APP_TYPE === 'PUBLIC' ? (
                    <Button
                      variant='contained'
                      onClick={this.signInGoogle}
                      className={classes.button}
                      startIcon={<GoogleIcon />}
                      fullWidth
                      style={{ backgroundColor: '#ffffff', border: '1px solid #d7dcf5', color: '#10142b', boxShadow: 'none' }}
                      disabled={setEmail} // COMMENT OUT LOCAL HOST
                    >
                      Login with Google
                    </Button>
                  ) : null}
                </Grid>
                
                {/* All remaining login UI: OTP back button, account recovery, links, etc. — 100% unchanged */}
                {/* ... everything from your original code is preserved below ... */}

                <div style={{ marginTop: '20px' }}>
                  <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1} style={{ marginBottom: '8px' }}>
                    <Grid item>
                      <span
                        className={classes.createAccount}
                        style={{
                          pointerEvents: setEmail ? 'none' : 'auto',
                          opacity: setEmail ? 0.1 : 1,
                          cursor: setEmail ? 'default' : 'pointer',
                        }}
                        onClick={setEmail ? null : this.handleToggleLoginSignUp}
                      >                        
                        Create Account
                      </span>
                    </Grid>
                    <Grid item>
                      {!setEmail && (<ForgotPassword />)}
                    </Grid>
                    <Hidden xsDown>
                      <Grid item>
                        <span
                          className={classes.createAccount}
                          style={{
                            pointerEvents: setEmail ? 'none' : 'auto',
                            opacity: setEmail ? 0.1 : 1,
                            cursor: setEmail ? 'default' : 'pointer',
                          }}
                          onClick={setEmail ? null : this.openSupportPage}
                        >
                          Account recovery
                        </span>
                      </Grid>
                    </Hidden>
                  </Grid>
                  
                  <Hidden smUp>
                    <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
                      <Grid item>
                        <span
                          className={classes.createAccount}
                          style={{
                            pointerEvents: setEmail ? 'none' : 'auto',
                            opacity: setEmail ? 0.1 : 1,
                            cursor: setEmail ? 'default' : 'pointer',
                          }}
                          onClick={setEmail ? null : this.openSupportPage}
                        >
                          Account recovery
                        </span>
                      </Grid>
                    </Grid>
                  </Hidden>
                </div>
              </Grid>
            </Grid>
          ) : APP_TYPE === 'PUBLIC' ? (
            /* ==================== ORIGINAL SIGNUP FORM (100% PRESERVED) ==================== */
            <Grid item xs={12} sm={7} md={7} className={classes.formPanel}>
              <Media queries={{ small: '(max-width: 599px)' }}>
                {matches =>
                  matches.small ?
                    <img src={ThinkLeadLogo} style={{ width: '100%', height: 'auto', borderRadius: FIELD_RADIUS, marginBottom: 24 }} />
                    : null
                }
              </Media>

              <Typography className={classes.formEyebrow}>JOIN THE ECOSYSTEM</Typography>
              <Typography variant="h5" className={classes.formHeading}>
                Create your account
              </Typography>
              <Typography className={classes.formSubtext}>
                LEAD, learn, and start earning Lc toward MEV.
              </Typography>

              {/* SIGNUP FORM */}
              <TextField
                variant='outlined'
                margin='dense'
                value={firstName}
                placeholder='First Name'
                fullWidth='true'
                onChange={this.handleChange('firstName')}
                style={{ backgroundColor: '#ffffff', borderRadius: FIELD_RADIUS, marginBottom: 10 }}
              />
              
              <TextField
                variant='outlined'
                margin='dense'
                value={lastName}
                placeholder='Last Name'
                fullWidth='true'
                onChange={this.handleChange('lastName')}
                style={{ backgroundColor: '#ffffff', borderRadius: FIELD_RADIUS, marginBottom: 10 }}
              />
              
              <TextField
                variant='outlined'
                margin='dense'
                value={this.state.username}
                placeholder='Email'
                type='email'
                fullWidth='true'
                disabled={true}
                onChange={this.handleChange('email')}
                style={{ backgroundColor: '#ffffff', borderRadius: FIELD_RADIUS, marginBottom: 10 }}
              />
              
              <TextField
                id='signup-password'
                variant='outlined'
                margin='dense'
                placeholder='Password'
                value={password}
                type={showPassword ? 'text' : 'password'}
                autoComplete='new-password'
                fullWidth='true'
                onChange={this.handleChange('password')}
                style={{ backgroundColor: '#fff', borderRadius: FIELD_RADIUS }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        aria-label='Toggle password visibility'
                        onClick={this.handleClickShowPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility /> }
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />

              <FormControl fullWidth style={{ marginTop: 10, marginBottom: 5 }}>
                <InputLabel id='position-label'>Select Position/Title</InputLabel>
                <Select
                  labelId='position-label'
                  id='position'
                  value={this.state.position}
                  onChange={this.handleChange('position')}
                  style={{ backgroundColor: '#ffffff', borderRadius: FIELD_RADIUS }}
                  MenuProps={MenuProps}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    <em>Select Position/Title</em>
                  </MenuItem>
                  {this.renderGeneralSettings('position')}
                </Select>
              </FormControl>

              <FormControl fullWidth style={{ marginTop: 5, marginBottom: 5 }}>
                <InputLabel id='department-label'>Select Sector/Industry</InputLabel>
                <Select
                  labelId='department-label'
                  id='department'
                  value={this.state.department}
                  onChange={this.handleChange('department')}
                  style={{ backgroundColor: '#ffffff', borderRadius: FIELD_RADIUS }}
                  MenuProps={MenuProps}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    <em>Select Sector/Industry</em>
                  </MenuItem>
                  {this.renderCompanySettings('departments')}
                </Select>
              </FormControl>

              <FormControl fullWidth style={{ marginTop: 5, marginBottom: 10 }}>
                <InputLabel id='nationality-label'>Select Country</InputLabel>
                <Select
                  labelId='nationality-label'
                  id='nationality'
                  value={this.state.nationality}
                  onChange={this.handleChange('nationality')}
                  style={{ backgroundColor: '#ffffff', borderRadius: FIELD_RADIUS }}
                  MenuProps={MenuProps}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    <em>Select Country</em>
                  </MenuItem>
                  {this.renderGeneralSettings('nationality')}
                </Select>
              </FormControl>

              {/* Terms and Conditions Checkbox */}
              <div style={{ 
                marginTop: 16, 
                marginBottom: 15, 
                paddingLeft: 0,
                backgroundColor: '#f7f8fc',
                borderRadius: FIELD_RADIUS,
                padding: '10px 15px',
                border: '1px solid #e8eaf5'
              }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={agreeTCs}
                      onChange={this.handleChecked('agreeTCs')}
                      value='agreeTCs'
                      color='primary'
                    />
                  }
                  label={
                    <span style={{ fontSize: '14px', color: '#333' }}>
                      I agree to the{' '}
                      <span
                        style={{ 
                          color: '#2980B9', 
                          cursor: 'pointer', 
                          textDecoration: 'underline' 
                        }}
                        onClick={this.handleViewTermsAndConditions}
                      >
                        ThinkLead Terms and Conditions
                      </span>
                      {' '}and{' '}
                      <span
                        style={{ 
                          color: '#2980B9', 
                          cursor: 'pointer', 
                          textDecoration: 'underline' 
                        }}
                        onClick={this.handleViewPolicy}
                      >
                        Cookie Policy
                      </span>
                    </span>
                  }
                  style={{ margin: 0 }}
                />
              </div>

              {/* Sign Up Buttons */}
              <Grid container direction='row' spacing={2} style={{ marginTop: 25, marginBottom: 15 }}>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant='contained'
                    onClick={this.SignUpWithEmail}
                    disabled={isSignupInvalid}
                    className={classes.button}
                    fullWidth
                    style={{ 
                      marginTop: 0,
                      borderRadius: FIELD_RADIUS,
                      height: 50
                    }}
                  >
                    SIGN UP
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant='contained'
                    onClick={this.signInGoogle}
                    disabled={!agreeTCs}
                    fullWidth
                    startIcon={<GoogleIcon />}
                    style={{ 
                      marginTop: 0,
                      backgroundColor: '#ffffff',
                      borderRadius: FIELD_RADIUS,
                      border: '1px solid #d7dcf5',
                      color: '#10142b',
                      height: 50,
                      textTransform: 'none',
                      fontWeight: 600
                    }}
                  >
                    Sign up with Google
                  </Button>
                </Grid>
              </Grid>

              {/* Show helper text when required fields are missing */}
              {isSignupInvalid && (
                <div style={{ 
                  marginTop: 10, 
                  padding: '10px', 
                  backgroundColor: '#fff3cd', 
                  border: '1px solid #ffc107',
                  borderRadius: FIELD_RADIUS,
                  fontSize: '14px',
                  color: '#856404',
                  textAlign: 'center'
                }}>
                  {/* {password.trim().length < 7 && <div>• Password must be at least 7 characters</div>}
                  {!firstName && <div>• First name is required</div>}
                  {!lastName && <div>• Last name is required</div>}
                  {!email && <div>• Email is required</div>}
                  {!agreeTCs && <div>• You must agree to Terms and Conditions</div>} */}
                  {password.trim().length < 6 && <div>• Password must be at least 6 characters</div>}                  {!firstName.trim() && <div>• First name is required</div>}
                  {!lastName.trim() && <div>• Last name is required</div>}
                  {currentEmail.trim() === '' && <div>• Email is required</div>}  {/* Only show if truly empty */}
                  {!agreeTCs && <div>• You must agree to Terms and Conditions</div>}
                </div>
              )}

              {/* Back to Login */}
              <Grid container direction='row' justify='center' style={{ marginTop: 25, marginBottom: 15 }}>
                <span
                  className={classes.createAccount}
                  onClick={this.handleToggleLoginSignUp}
                >
                  Already have an account? Sign In
                </span>
              </Grid>
            </Grid>
          ) : null}
        </Grid>

        {/* Dialogs remain unchanged — your full Terms and Cookie Policy dialogs go here exactly as before */}
          <Dialog
            open={this.state.openTandC}
            onClose={this.handleCloseTandC}
            aria-labelledby='scroll-dialog-title'>
            <DialogTitle id='scroll-dialog-title'>Terms and Conditions</DialogTitle>
            <DialogContent dividers={this.state.scroll === 'paper'}>
            <div style={{ display: 'block' }}>

<h3>1. Me Vision Ecosystem (MV) Conditions</h3>

<p>MV is an exclusive digital ecosystem for continuous personal development, uniting current and future Successful Leaders who champion our purpose: transforming leadership standards in partnership with likeminded leaders globally, by mobilising thousands—eventually millions—toward their Best Selves. We redefine leadership across all dimensions—self, others, organisations, and society (SOOS)—spanning all levels, sectors, and countries. MV connects successful leaders and individuals who’ve found their purpose, countering the negative trajectory of leadership standards, emotional well-being, unemployment of youth, the rise of AI and financial prosperity. We’re forging confident humans and powerful leaders, with financial prosperity as a reward for those who fuel our vision to mobilise 30,000 leaders by 2030, then 30,000 per country.</p>

<p>Inside MV, you may share messages—informative, inspirational, announcements, news, or anything impactful—called a LEAD, not a post or share. Every LEAD influences society, collectively and individually, to some degree. We urge members to embody their Best Self and THINK before they LEAD, as each LEAD shapes how we think. A LEAD may earn you Lead Currency (Lc) that becomes MeV, our currency, as a thank-you for adding value—potentially rewarded when others like or comment, reflecting your impact.</p>

<p>Members join MV to:</p>
<ul>
  <li>LEAD with content that helps leaders LEAD better on a Self, Others, Organisation and Society level.</li>
  <li>LEAD on any subject, amplifying their voice;</li>
  <li>LEAD with insights, wisdom, or experiences;</li>
  <li>LEAD to positively impact the world;</li>
  <li>LEAD for personal and leadership growth;</li>
  <li>LEAD to earn MeV, enhancing future influence and benefits;</li>
  <li>LEAD to build their personal or leadership brand, generating “leads” for their business, service, or cause;</li>
  <li>And much more—now and as we evolve.</li>
</ul>

<p>MV is a global community of confident individuals and Successful Leaders who see the urgent need for mature, authentic leadership. Members are honoured to participate, learning from each other, contributing positively, and striving to improve the world for future generations.</p>

<h3>How MEV Works:</h3>
<p>MV participants earn internal Lc (Lead Currency) for pledges and engagement, convertible to MEV (Me Vision)—our external currency—upon reaching thresholds set by MV management. Leaders or their sponsors pledge monthly in dollars via platforms like Patreon, which MV converts into Lc. Portions of pledges:</p>
<ul>
  <li>Reward patrons with MeV – 25% after Patreon fee is subtracted.</li>
  <li>Fund MV operations and maintenance.</li>
  <li>Build a communal pool from which members earn Lc for ecosystem activities.</li>
</ul>
<p>MV management reserves the right to adjust Lc allocation, MEV conversion ratios, and pledge distributions to ensure sustainable liquidity. This pioneering venture is dynamic—changes will occur as we learn, and we’re all grateful to replace simple gamification points with Lc and MEV instead, a currency reflecting our collective value. MV grows a wealth of leadership while fostering leaders’ prosperity. Every MEV movement signals improved leadership—individual or communal—adding tangible value to the world.</p>

<ul>
  <li><strong>Phase One:</strong> Members grow MEV portfolios, building liquidity. You acknowledge MEV’s value extraction (selling) is a future step, not yet active - in development Phase completed</li>
  <li><strong>Phase Two:</strong> As MeV gains external value, selling will phase in—staged to strengthen liquidity until investors can freely trade MEV, like any digital currency. Members commit to this evolution, understanding delays may occur as we scale and stabilise. This phase in in full swing. Members may now sell their MEV for cash in their bank accounts. However, MV Management withholds the right to determine levels allowed per month – how much MEV a member may sell in one month. Members accept this phase where no member may cash in all their MEV if it is more than the current monthly limit. This phase is important as we further strengthen liquidity and MEV price. The ultimate measurement is that the collective platform success and longevity is more important than one individual’s immediate need. The threshold decision is made through a co-signing process on the system. In other words, no individual can randomly decide what it is.</li>
  <li><strong>Authenticity Commitment:</strong> Members agree not to flood the system with “earning activities” solely for MEV, without genuine intent to develop themselves, others, organisations, society or MV. MV may audit a members’ actions to ensure they align with our purpose, reserving the right to adjust or revoke MeV if intent is misaligned.</li>
  <li><strong>Patron Requirement:</strong> Only patrons (those pledging monthly) can earn MEV. MV may, at its discretion, onboard non-patron emerging leaders with potential when the global incentive fund allows, but this is not guaranteed.</li>
  <li><strong>Improvement Architects (IA’s):</strong> We currently recruit tech savvy individuals – mostly youngsters – to drive the Global Improvement Revolution of SOOS. IA’s are allowed to earn Lc for their participation and contributions without pledging. They draw good content to the platform and earn real-time certificates as they complete one another’s tests. They therefore prepare to lead the future while helping leaders lead better in our current world.</li>
  <li><strong>Pledge Confirmation:</strong> MV confirms monthly pledges on Patreon to automatically distribute Lc.</li>
  <li><strong>Lc Conversion to MEV:</strong> Members convert their earned Lc into MEV themselves. They need to learn to do this as soon as they become active participants.</li>
</ul>

<h3>MV Features:</h3>
<ul>
  <li>A growing library of leadership content—accessible on phone, tablet, and laptop—magnetising inspiration and conversation.</li>
  <li>An exclusive space with a Global Leaderboard on LeaderTrack, able to rank members by earned Lc, feedback scores or other criteria, visible globally or by sector, country, and level. Members consent to this display (toggleable on/off), showcasing quality leaders to the world.</li>
  <li>A pioneering ecosystem potentially “professionalizing” leadership—MeV mirrors CPD points in other fields. Members compile a portfolio of participation and MeV earned, printable as evidence of growth. They receive real-time certificates as proof, recorded inside their resume.</li>
  <li>A real-time communication hub for leaders across organizations and society, tackling leadership’s communication challenge.</li>
  <li>A web-based platform (future native app possible) for all leadership content within community guidelines.</li>
  <li>A network where members follow/unfollow others, controlling LEAD notifications.</li>
  <li>An organizational tool for real-time feedback, analysis, and development from top leaders.</li>
  <li>Anonymous leadership ratings on profiles—based on four universal competencies (self, others, organization, society) or organization-specific ones—available to all members.</li>
</ul>

<h3>MV Co-Owners:</h3>
<p>Members may open their own MV ecosystems to mobilize leaders globally, earning residual commissions for recruiting paying Partners and Successful Leaders, as long as recruits remain active. Details will evolve—stay tuned.</p>

<h3>Community Guidelines:</h3>
<p>LEAD with any subject, but the following is prohibited:</p>
<ul>
  <li>Nudity or sexual content (pornography, explicit fetishes—removed without notice).</li>
  <li>Hateful content (inciting violence, dangerous/illegal acts—strictly banned).</li>
  <li>Privacy violations (sharing personal info without consent—request removal from uploader first, then report to MV).</li>
  <li>Threats (harassment, stalking, reputation damage—may result in permanent bans).</li>
  <li>Vulgar language (excessive profanity—deleted without notice).</li>
</ul>
<p>Report inappropriate content via the feedback function; MV reviews daily against these guidelines. You accept that occasional objectionable content may slip through, waiving legal claims against MV for such exposure.</p>

<h3>2. Your Personal Relationship with MV</h3>
<ul>
  <li>“MV” means Me-Vision Ecosystem, at this stage a service of ThinkLead Pty Ltd, at 2932 Korhaan Str, Marloth Park, Mpumalanga, South Africa. This may change in due course.</li>
  <li>These Terms form a legally binding contract between you and MV for your use of the Service—read them carefully.</li>
  <li>“Content” includes all text, media, courses, and materials you view, access, or contribute via the Service.</li>
</ul>

<h3>3. Accepting the Terms</h3>
<ul>
  <li>To use the Service, you must accept these Terms—accessing MV via Thinklead.app constitutes agreement.</li>
  <li>By using MV, you confirm you’re of legal age to form a binding contract (e.g., 18 under South African law, or as per your jurisdiction) and not barred from digital services under your country’s laws.</li>
  <li>If you don’t accept, you may not join—usage implies consent from your first interaction.</li>
</ul>

<h3>4. Changes to the Terms</h3>
<ul>
  <li>MV may modify these Terms to reflect legal, regulatory, or Service updates—changes will be promoted on Thinklead.app with an updated Effective Date.</li>
  <li>You’re responsible for reviewing Terms periodically—continued use after modifications signals acceptance. If you disagree, cease using MV immediately.</li>
  <li>Material changes (e.g., affecting MeV conversion) will, where feasible, include a notice period via email or platform announcement.</li>
</ul>

<h3>5. MV Accounts</h3>
<ul>
  <li>Access to features like LeaderTrack or MeV earning requires an MV account—provide accurate, current information during signup.</li>
  <li>Secure your password and notify MV at info@mevisionacademy.com immediately of any breach or unauthorized use—you’re liable for all account activity.</li>
  <li>MV grants you a non-exclusive, revocable license to use the Service, provided you don’t:
    <ol>
      <li>Distribute Content without MV’s written consent (unless enabled by MV tools);</li>
      <li>Modify the platform’s code or interface;</li>
      <li>Circumvent security features or restrictions on Content use;</li>
      <li>Harvest user data (e.g., account names);</li>
      <li>Solicit commercially via MV tools;</li>
      <li>Exploit Content without permission from MV or its licensors.</li>
    </ol>
  </li>
  <li>MV may innovate—features may change or end without notice; you accept this as part of our pioneering journey.</li>
</ul>

<h3>6. Links from MV</h3>
<ul>
  <li>MV may link to third-party sites beyond our control—we’re not responsible for their content, policies, or availability.</li>
  <li>We don’t endorse or guarantee these sites—use them at your own risk, reviewing their terms and privacy policies.</li>
  <li>MV isn’t liable for losses from third-party links, including reliance on their accuracy or offerings.</li>
</ul>

<h3>7. Ending Your Relationship with MV</h3>
<ul>
  <li>You may terminate by: (a) emailing info@mevisionacademy.com, (b) closing your account, or (c) not renewing your pledge—MV will delete your data upon written request, barring legal retention needs.</li>
  <li>MV may terminate if:
    <ol type="a">
      <li>You breach Terms (e.g., inauthentic MeV earning);</li>
      <li>Law mandates it (e.g., sanctions);</li>
      <li>Service ends in your region or becomes unviable—reasonable notice given where possible;</li>
      <li>You’re inactive and non-paying for 6+ months—account may be closed after a 30-day warning.</li>
    </ol>
  </li>
  <li>Post-termination, accrued rights (e.g., earned MeV) and obligations (e.g., confidentiality) persist as applicable.</li>
</ul>

<h3>8. Exclusion of Warranties</h3>
<ul>
  <li>MV is provided “as is”—no promises of uninterrupted, error-free, or requirement-specific use.</li>
  <li>We don’t guarantee: (a) Service meets your needs; (b) it’s always secure or timely; (c) info is accurate; (d) defects will be fixed—use at your discretion.</li>
  <li>No implied warranties (e.g., merchantability) apply beyond what law mandates.</li>
</ul>

<h3>9. Limitation of Liability</h3>
<ul>
  <li>MV isn’t liable for indirect losses (e.g., profit, goodwill, data) or damages from:
    <ol>
      <li>Reliance on ads or third-party transactions;</li>
      <li>Service changes or cessation;</li>
      <li>Data loss/corruption;</li>
      <li>Inaccurate account info or security failures on your end.</li>
      <li>MEV depreciating for whatever reason</li>
    </ol>
  </li>
  <li>Liability is capped at your total pledges paid, where law allows—direct damages only.</li>
</ul>

<h3>10. General Legal Terms</h3>
<ul>
  <li>These Terms are the full agreement—prior understandings are void.</li>
  <li>Notices (e.g., MeV updates) may come via email, mail, or Thinklead.app postings—check regularly.</li>
  <li>MV’s non-enforcement of rights isn’t a waiver—invalid provisions don’t void the rest.</li>
  <li>Governed by South African law—disputes resolved in South African courts, unless arbitration is later specified.</li>
</ul>

<h3>11. Global Contributors for MV</h3>
<ul>
  <li><strong>Organizations:</strong> MV auto-follows Global Contributors for internal messaging—members can unfollow.</li>
  <li><strong>Contributors:</strong> You’re liable for Content legality—global Content grants MV a royalty-free, worldwide license to use, ending reasonably post-deletion (server copies may remain).</li>
  <li>No third-party IP infringement—MV removes violators, may ban repeat offenders without notice.</li>
  <li>MV disclaims liability for Content accuracy or endorsement—your posts, your responsibility.</li>
</ul>


              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseTandC} color='primary'>
            Close
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.openPolicy}
            onClose={this.handleClosePolicy}
            aria-labelledby='scroll-dialog-title'
          >
            <DialogTitle id='scroll-dialog-title'>Cookie Policy</DialogTitle>
            <DialogContent dividers={this.state.scroll === 'paper'}>
              <DialogContentText>
                <p>This website uses cookies to improve the user experience and ensure that it is functioning effectively, and on occasion also to provide marketing information or advertise online, either directly or through third party vendors.</p>

                <p>This Cookie Policy is part of 'ThinkLead' and/or its affiliates (hereafter referred as "ThinkLead", or "we") Privacy Policy. For more information about ThinkLead, and how it protects your information, please see the Privacy Policy.</p>

                <p>To provide you with a more personalized and responsive service, ThinkLead needs to remember and store information about how you use this website. This is done using small text files called cookies. Cookies contain small amounts of information and are downloaded to your computer or other device by a server for this website. Your web browser then sends these cookies back to this website on each subsequent visit so that it can recognize you and remember things like your user preferences. You can find more detailed information about cookies and how they work at https://www.aboutcookies.org.</p>

                <p>Whenever you use this website, information may be collected using cookies and other technologies. By using this website you agree to ThinkLead's use of cookies as described in this Cookie Policy and also to the use of cookies on the other country, regional or practice specific websites contained in ThinkLead.app that you may visit, as described in their accompanying cookie policy.</p>

                <p>What cookies does ThinkLead use and why?</p>

                <p>Following cookies may be used at ThinkLead:</p>

                <ul>
                  <li>Essential cookies</li>
                  <li>Performance cookies</li>
                  <li>Functionality cookies</li>
                  <li>Behaviorally Targeted Advertising cookies</li>
                  <li>Compliance, Security Authentication Cookies</li>
                  <li>Notification Cookies</li>
                </ul>

                <p>ThinkLead or its service providers also use analytic services to understand how effective ThinkLead's content is, what interests ThinkLead's users have, and to improve how this website works. In addition, ThinkLead uses web beacons, or tracking pixels to count visitor numbers and performance cookies to track how many individual users access this website and how often. This information is used for statistical purposes only and it is not ThinkLead's intention to use such information to personally identify any user. However, if you have registered and signed into this website, ThinkLead may combine this information with information from its web analytic services and cookies to analyze how you use this website in more detail.</p>

                <p>Please contact ThinkLead, through any of the means highlighted in our Privacy Policy, if you would like more detailed information on the cookies it uses.</p>

                <h3>How to Control Cookies?</h3>
                <p>By using this website, you agree that ThinkLead can place cookies on your computer or device as explained above. However, you can control and manage cookies in various ways. Please bear in mind that removing or blocking cookies can impact user experience and parts of this website may no longer be fully accessible.</p>

                <h3>Social Buttons and/or External Web Services</h3>
                <p>The website contains 'social buttons' that enable users to share or bookmark web pages. These are buttons for third party social media sites and these sites may log information about your activities on the Internet including on this website. ThinkLead sometimes also uses external web services on this website to display content within the web pages of this website, for example to display images, show videos or run polls. As with the social buttons, ThinkLead cannot prevent these sites, or external domains, from collecting information on your use of this embedded content. Please review the respective terms of use and privacy policies/statements/notices of these sites, or external domains to understand exactly how they use your information and to find out how to opt-out, or delete, such information.</p>

                <h3>Amendment to the policy</h3>
                <p>Further, ThinkLead may modify or amend this Cookie Policy from time to time at its discretion. When ThinkLead makes change to this policy, it will amend the revision date at the top of this page, and such modified or amended Cookie Policy shall be effective to you and your information as of that revision date. ThinkLead encourages you to periodically review this Cookie Policy to be informed about how it is using cookies.</p>

                <p>Most browsers will allow you to see what cookies you have and delete them on an individual basis or block cookies from particular or all websites. Be aware that any preference you have set will be lost if you delete all cookies, including your preference to opt-out from cookies as this itself requires an opt-out cookie to have been set. For more information on how to modify your browser settings to block or filter cookies, see https://www.aboutcookies.org or http://www.cookiecentral.com/faq</p>

                <p>You can opt-out of having your anonymized browsing activity within websites recorded by analytics cookies. ThinkLead use the following service providers and you can learn more about their privacy policies and how to opt-out of their cookies by clicking on following links:
Google Analytics: http://www.google.com/analytics/learn/privacy.html</p>

                <p>A local shared object is like most other browser cookies except that it can store additional types of information. These cookies cannot be controlled using the mechanisms listed above. Some parts of this website may use these types of cookies to store user preferences for media player functionality and without them some video content may not play properly. </p>

                <h3>Notification Cookies</h3>
                <p>These cookies are used to improve your use of the site by allowing notices of information and options. For example, ThinkLead may use the cookie to allow us to stop showing you the signup notification if you have already seen it.</p>

                <h3>Compliance, Security Authentication Cookies</h3>
                <p>These cookies are used to prevent fraud, protect your data from unauthorized parties and to comply with legal requirements. For example, these cookies will be used to determine if you are logged in.</p>

                <h3>Functionality cookies</h3>
                <p>We use functionality cookies to allow us to remember your preferences. For example, cookies recall your customization preferences, such as which regional edition of the website you want to see when you log in.</p>

                <h3>Performance cookies</h3>
                <p>We utilize other cookies to analyze how our visitors use our websites and to monitor website performance. This allows us to provide a high quality experience by customizing our offering and quickly identifying and fixing any issues that arise. For example, we might use performance cookies to keep track of which pages are most popular, which method of linking between pages is most effective, and to determine why some pages are receiving error messages. We might also use these cookies to highlight articles or site services that we think will be of interest to you based on your usage of the website.</p>

                <h3>Essential cookies</h3>
                <p>Some cookies are essential for the operation of our website. For example, some cookies allow us to identify subscribers and ensure they can access the subscription only pages. If a subscriber opts to disable these cookies, the user will not be able to access all of the content that a subscription entitles them to.</p>

                <p>ThinkLead and/or its affiliates ("ThinkLead," the "Company," "we," "us," and "our,") respect your privacy and is committed to protecting it through its compliance with its privacy policies. This policy describes:</p>

                <p>the types of information that ThinkLead may collect from you when you access or use its websites, applications and other online services (collectively, referred as "Services"); and
its practices for collecting, using, maintaining, protecting and disclosing that information.</p>

                <p>This policy applies only to the information ThinkLead collects through its Services, in email, text and other electronic communications sent through or in connection with its Services.</p>

                <p>This policy DOES NOT apply to information that you provide to, or that is collected by, any third-party, such as restaurants at which you make reservations and/or pay through ThinkLead's Services and social networks that you use in connection with its Services. ThinkLead encourages you to consult directly with such third-parties about their privacy practices</p>.

                <p>Please read this policy carefully to understand ThinkLead's policies and practices regarding your information and how ThinkLead will treat it. By accessing or using its Services and/or registering for an account with ThinkLead, you agree to this privacy policy and you are consenting to ThinkLead's collection, use, disclosure, retention, and protection of your personal information as described here. If you do not provide the information ThinkLead requires, ThinkLead may not be able to provide all of its Services to you.</p>

                <p>If you reside in a country within the European Union/European Economic Area (EAA), United States of America, any other part of the world, ThinkLead will be the controller of your personal data provided to, or collected by or for, or processed in connection with our Services;</p>

                <p>Your data controller is responsible for the collection, use, disclosure, retention, and protection of your personal information in accordance with its privacy standards as well as any applicable national laws. Your data controller may transfer data to other members of ThinkLead as described in this Privacy Policy. ThinkLead may process and retain your personal information and/or on the servers of its third parties (in or outside India), having contractual relationships with ThinkLead.</p>

                <p>This policy may change from time to time, your continued use of ThinkLead's Services after it makes any change is deemed to be acceptance of those changes, so please check the policy periodically for updates.</p>

                <h3>EU General Data Protection Regulation (GDPR) has provided the below rights to the EU residents:</h3>

                <ul>
                  <li>Right to information - including contact details to the DPO, the purposes for processing Personal Information and the rights of the individual.</li>
                  <li>Right to access the Personal Information that are processed</li>
                  <li>Right to erasure ("Right to be forgotten")</li>
                  <li>Right to rectification</li>
                  <li>Right to restriction of processing</li>
                  <li>Right to data portability of the Personal Information supplied to ThinkLead by the EU resident</li>
                  <li>Right to object (opt-out) to processing (unless ThinkLead otherwise has compelling legitimate grounds)</li>
                </ul>

                <p>EU residents can exercise these rights by raising a request directly at support@thinklead.co.za or contact us at the information provided in CONTACT US section.
</p>

                <h3>Contact us</h3>
                <p>If you have any queries relating to the processing/ usage of information provided by you or ThinkLead's Privacy Policy, you may email the Data Protection Officer (DPO) at support@thinklead.co.za or write to us at the following address.</p>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClosePolicy} color='primary'>
            Close
              </Button>
            </DialogActions>
          </Dialog>
      </Container>
      </div>
    </React.Fragment>
  )
}

}

const BodyContentStyled = withStyles(styles)(BodyContent)
// ===============
const mapStateToProps = state => {
  return {
    company_settings: state.users.company_settings,
    general_settings: state.users.general_settings,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signInEmail: creds => dispatch(signInWithEmailAndPassword(creds)),
    SignUpWithEmail: params => dispatch(signUpNewUsers(params)),
    checkUserIs: params => dispatch(checkUserIs(params)),
    createCompanyUser: params => dispatch(createCompanyUser(params)),
    signGoogle: params => dispatch(signInWithGoogle(params)),
    showLoader: params => dispatch(showLoader(params)),
    hideLoader: params => dispatch(hideLoader(params)),
    resetPassword: params => dispatch(resetUserPassword(params)),
    getAllCompanySettings: params => dispatch(getAllCompanySettings(params)),
    getAllGeneralSettings: params => dispatch(getAllGeneralSettings(params)),
    showToast: params => dispatch(showToast(params)),
    clearAllLockouts: email => dispatch(clearAllLockoutsForUser(email)),
    getUserPhoneNumber: email => dispatch(getUserPhoneNumber(email)),
    recordFailedOTPAttempt: phoneNumber => dispatch(recordFailedOTPAttempt(phoneNumber)),
    checkOTPLockoutStatus: phoneNumber => dispatch(checkOTPLockoutStatus(phoneNumber)),
    clearOTPLockout: phoneNumber => dispatch(clearOTPLockout(phoneNumber)),
    sendEmailVerificationBypass: email => dispatch(sendEmailVerificationBypass(email)),
    verifyEmailBypassToken: (email, token) => dispatch(verifyEmailBypassToken(email, token)),
    signInEmailEnhanced: params => dispatch(signInWithEmailAndPasswordEnhanced(params)),
    checkDeviceTrustStatus: email => dispatch(checkDeviceTrustStatus(email)),
    addDeviceToTrustedList: (email, data) => dispatch(addDeviceToTrustedList(email, data)),
    removeDeviceFromTrustedList: (email, deviceId) => dispatch(removeDeviceFromTrustedList(email, deviceId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BodyContentStyled)